<template>
  <div :class="{ calendar: this.$store.state.splitPage }">
    <div :class="{ calendarSide: this.$store.state.splitPage }">
      <div :class="{ calendarSideContent: this.$store.state.splitPage }">
        <div class="fc-wrapper">
          <FullCalendar ref="fullCalendar" :options="calendarOptions" />
        </div>

        <template v-if="this.$store.state.showMonoPopupConduite">
          <MonoModal
            visible="true"
            :moniteurs="this.moniteurs"
            @getLesMoniteurs="getLesMoniteurs"
            :monoChecked="moniteurchoix"
            v-on:moniteurChoicePlanning="moniteurChoicePlanning"
            :choixMonoSaves="choixMonoSaves"
          />
        </template>

        <Dialog
          v-model:visible="resaModal"
          modal
          :style="{ width: '80rem', maxWidth: '98vw' }"
          :breakpoints="{ '960px': '95vw' }"
          class="resa-dialog resa-eleve-dialog"
        >
          <template #header>
            <div class="resa-eleve-banner">
              <div class="resa-eleve-banner-left">
                <span class="resa-eleve-banner-eleve">Réservation</span>
                <span class="resa-eleve-banner-date">{{ resaHeader }}</span>
              </div>
              <span class="resa-eleve-banner-boite" v-if="boiteResa">Boîte : {{ boiteResa }}<template v-if="prixBoiteResa != null"> · {{ prixBoiteResa }}€</template></span>
            </div>
          </template>

          <div class="resa-head">
            <div class="resa-head-toggles">
              <label class="resa-toggle">
                <input
                  type="checkbox"
                  name="otherStudentDispo"
                  id="otherStudentDispo"
                  @change="getDispoElevesOtherMono"
                  v-model="cbxDispoOtherMono"
                />
                <span>Autre élève dispo</span>
              </label>

              <label class="resa-toggle">
                <input
                  type="checkbox"
                  name="allStudent"
                  id="allStudent"
                  @change="getAllEleves"
                  v-model="cbxAllStudents"
                />
                <span>Tous les élèves</span>
              </label>
            </div>
          </div>

          <div class="overlap-warning" v-if="cancelledOverlap">
            <div class="overlap-warning-text">
              <strong>{{ cancelledOverlap.eleve.fullname }}</strong> avait un cours sur ce créneau ({{ cancelledOverlapRange }}), annulé pour "{{ cancelledOverlap.typeMotif }}".
            </div>
            <button class="overlap-warning-btn" @click="reactivateOverlap" :disabled="loadReactivateOverlap">
              {{ loadReactivateOverlap ? "Remise en cours..." : "Remettre le cours" }}
            </button>
          </div>

          <div class="resa-table-wrap">
            <template v-if="showEleveDispo">
              <DataTable
                :value="eleveDispos"
                tableStyle="width: 100%"
                class="resa-eleves-table"
              >
                <Column field="code" header="">
                  <template #body="{ data }">
                    <input
                      type="radio"
                      class="resa-radio"
                      name="eleve"
                      :id="data.id"
                      :value="data.id"
                      @click="getLieuEleve(data)"
                      v-model="idEleveChoixResa"
                    />
                  </template>
                </Column>
                <Column field="nom" header="Nom"></Column>
                <Column field="prenom" header="Prénom"></Column>
                <Column field="telephone" header="Tel"></Column>
                <Column field="dossier.adresse.ville" header="Ville"></Column>
                <Column field="solde" header="Solde"></Column>
                <Column field="boiteNom" header="Boite"></Column>
                <Column field="heureTot" header="Heure à prog"></Column>
              </DataTable>
              <Paginator
                :rows="10"
                :totalRecords="countElevesList"
                @page="onPaginateDispo"
                class="resa-paginator"
              ></Paginator>
            </template>
            <template v-else>
              <DataTable :value="lesEleves" tableStyle="width: 100%" :rows="10" class="resa-eleves-table">
                <Column field="code" header="">
                  <template #body="{ data }">
                    <input
                      type="radio"
                      class="resa-radio"
                      name="eleve"
                      :id="data.id"
                      :value="data.id"
                      @click="getLieuEleve(data)"
                      v-model="idEleveChoixResa"
                    />
                  </template>
                </Column>
                <Column field="nom" header="Nom"></Column>
                <Column field="prenom" header="Prénom"></Column>
                <Column field="telephone" header="Tel"></Column>
                <Column field="dossier.adresse.ville" header="Ville"></Column>
                <Column field="solde" header="Solde"></Column>
                <Column field="boiteNom" header="Boite"></Column>
                <Column field="heureTot" header="Heure à prog"></Column>
              </DataTable>
              <Paginator
                :rows="10"
                :totalRecords="countElevesList"
                @page="onPaginate"
                class="resa-paginator"
              ></Paginator>
            </template>
          </div>

          <template v-if="idEleveChoixResa != null">
            <template v-if="this.eleveChoixResa.choixDispo != 'null'">
              <div class="resa-lieux">
                <div class="field-group">
                  <label class="field-label">Lieu de début</label>
                  <select
                    name="debLieu"
                    id="debLieu"
                    class="field-input"
                    v-model="lieuDebChoix"
                  >
                    <option>Lieu de début</option>
                    <template v-for="l in lieuxMono" :key="l.id">
                      <template v-if="l.choixEleve == true">
                        <option :value="l.id" :title="l.fulladresse">
                          {{ l.nom }}
                        </option>
                      </template>
                      <template v-else>
                        <template v-if="$store.state.user.agence.idl === l.id">
                          <option :value="l.id" :title="l.fulladresse">
                            {{ l.nom }}
                          </option>
                        </template>
                      </template>
                    </template>
                  </select>
                </div>

                <div class="field-group" v-if="lieuDebChoix != null">
                  <label class="field-label">Lieu de retour</label>
                  <select
                    name="finLieu"
                    id="finLieu"
                    v-model="lieuFinChoix"
                    class="field-input"
                  >
                    <option>Lieu de retour</option>
                    <template v-for="l in lieuxMono" :key="l.id">
                      <template v-if="l.choixEleve == true">
                        <option :value="l.id" :title="l.fulladresse">
                          {{ l.nom }}
                        </option>
                      </template>
                      <template v-else>
                        <template v-if="$store.state.user.agence.idl === l.id">
                          <option :value="l.id" :title="l.fulladresse">
                            {{ l.nom }}
                          </option>
                        </template>
                        <template v-if="l.id == 1000">
                          <option :value="l.id" :title="l.fulladresse">
                            {{ l.nom }}
                          </option>
                        </template>
                      </template>
                    </template>
                  </select>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="resa-warning">
                L'élève sélectionné doit choisir ses moniteurs et lieux de
                rendez-vous avant de pouvoir réserver un cours de conduite
              </div>
            </template>
          </template>

          <template v-if="lieuFinChoix != null">
            <template v-if="idEleveChoixResa != null">
              <div class="resa-actions">
                <template v-if="loadResaModalBtn == false">
                  <button class="resa-validate-btn" @click="setApointment">
                    Valider
                  </button>
                </template>
                <template v-else>
                  <button
                    @click="setApointment()"
                    class="resa-validate-btn"
                    disabled
                  >
                    <span><i class="fa fa-spinner fa-spin"></i>Valider</span>
                  </button>
                </template>
              </div>
            </template>
          </template>
        </Dialog>

        <Dialog
          v-model:visible="resaPopupEleve"
          modal
          :style="{ width: '60rem', maxWidth: '98vw' }"
          :breakpoints="{ '768px': '95vw' }"
          class="resa-eleve-dialog"
        >
          <template #header>
            <div class="resa-eleve-banner">
              <div class="resa-eleve-banner-left">
                <span class="resa-eleve-banner-eleve">{{ eleveChoixResa ? eleveChoixResa.fullname : "" }}</span>
                <span class="resa-eleve-banner-date">{{ resaHeader }}</span>
              </div>
              <span class="resa-eleve-banner-boite" v-if="boiteResa">Boîte : {{ boiteResa }}<template v-if="prixBoiteResa != null"> · {{ prixBoiteResa }}€</template></span>
            </div>
          </template>
          <!-- Simulateur -->
          <template v-if="apSimu == true">
            <template v-for="l in lieuxMono" :key="l.id">
              <div class="d-body">
                <div class="overlap-warning" v-if="cancelledOverlap">
                  <div class="overlap-warning-text">
                    <strong>{{ cancelledOverlap.eleve.fullname }}</strong> avait un cours sur ce créneau ({{ cancelledOverlapRange }}), annulé pour "{{ cancelledOverlap.typeMotif }}".
                  </div>
                  <button class="overlap-warning-btn" @click="reactivateOverlap" :disabled="loadReactivateOverlap">
                    {{ loadReactivateOverlap ? "Remise en cours..." : "Remettre le cours" }}
                  </button>
                </div>
                <div class="simu-card">
                  <div class="simu-icon">
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M8 21h8M12 17v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  </div>
                  <div>
                    <p class="simu-desc">Cours sur simulateur</p>
                    <p class="simu-lieu">{{ l.nom }}</p>
                  </div>
                </div>
                <div class="d-actions">
                  <template v-if="loadResaModalBtn == false">
                    <button class="d-btn d-btn--primary" @click="this.lieuDebChoix = l.id; this.lieuFinChoix = l.id; setApointment();" v-if="popupMotif == false">
                      <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      Valider
                    </button>
                  </template>
                  <template v-else>
                    <button class="d-btn d-btn--primary" disabled v-if="popupMotif == false">
                      <i class="fa fa-spinner fa-spin"></i> Valider
                    </button>
                  </template>
                </div>
              </div>
            </template>
          </template>

          <!-- Réservation / Modification -->
          <template v-else>
            <div class="d-body">
              <div class="overlap-warning" v-if="cancelledOverlap">
                <div class="overlap-warning-text">
                  <strong>{{ cancelledOverlap.eleve.fullname }}</strong> avait un cours sur ce créneau ({{ cancelledOverlapRange }}), annulé pour "{{ cancelledOverlap.typeMotif }}".
                </div>
                <button class="overlap-warning-btn" @click="reactivateOverlap" :disabled="loadReactivateOverlap">
                  {{ loadReactivateOverlap ? "Remise en cours..." : "Remettre le cours" }}
                </button>
              </div>
              <div class="d-fields">
                <div class="d-field">
                  <label class="d-label">Lieu de début</label>
                  <select name="debLieu" id="debLieu" class="d-select" v-model="lieuDebChoix">
                    <option>Lieu de début</option>
                    <template v-for="l in lieuxMono" :key="l.id">
                      <template v-if="popupMotif == true">
                        <template v-if="lieuPrevAp[0] == ' ' + l.nom">
                          <template v-if="l.choixEleve == true">
                            <option style="color: blue" :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                          </template>
                          <template v-else>
                            <template v-if="$store.state.user.agence.idl === l.id">
                              <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                            </template>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="l.choixEleve == true">
                            <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="l.choixEleve == true">
                          <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                        </template>
                        <template v-else>
                          <template v-if="$store.state.user.agence.idl === l.id">
                            <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                          </template>
                        </template>
                      </template>
                    </template>
                  </select>
                </div>

                <template v-if="lieuDebChoix != null">
                  <div class="d-field">
                    <label class="d-label">Lieu de retour</label>
                    <select name="finLieu" id="finLieu" class="d-select" v-model="lieuFinChoix">
                      <option>Lieu de retour</option>
                      <template v-for="l in lieuxMono" :key="l.id">
                        <template v-if="popupMotif == true">
                          <template v-if="lieuPrevAp[1] == l.nom">
                            <template v-if="l.choixEleve == true">
                              <option style="color: blue" :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                            </template>
                            <template v-else>
                              <template v-if="$store.state.user.agence.idl === l.id">
                                <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                              </template>
                              <template v-if="l.id == 1000">
                                <option style="color: blue" :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                              </template>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="l.choixEleve == true">
                              <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                            </template>
                            <template v-else>
                              <template v-if="l.id == 1000">
                                <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                              </template>
                            </template>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="l.choixEleve == true">
                            <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                          </template>
                          <template v-else>
                            <template v-if="$store.state.user.agence.idl === l.id">
                              <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                            </template>
                            <template v-if="l.id == 1000">
                              <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                            </template>
                          </template>
                        </template>
                      </template>
                    </select>
                  </div>
                </template>
              </div>

              <template v-if="lieuFinChoix != null">
                <div class="d-actions">
                  <template v-if="loadResaModalBtn == false">
                    <button class="d-btn d-btn--primary" @click="setApointment" v-if="popupMotif == false">
                      <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      Valider
                    </button>
                  </template>
                  <template v-else>
                    <button @click="setApointment()" class="d-btn d-btn--primary" disabled>
                      <i class="fa fa-spinner fa-spin"></i> Valider
                    </button>
                  </template>
                  <template v-if="loadModifBtn == false">
                    <button class="d-btn d-btn--secondary" @click="putApointment" v-if="popupMotif == true">
                      <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      Modifier
                    </button>
                  </template>
                  <template v-else>
                    <button @click="putApointment()" v-if="popupMotif == true" class="d-btn d-btn--secondary" disabled>
                      <i class="fa fa-spinner fa-spin"></i> Modifier
                    </button>
                  </template>
                </div>
              </template>
            </div>
          </template>
        </Dialog>

        <Dialog
          v-model:visible="popupMotif"
          modal
          :style="{ width: '50rem', maxWidth: '98vw' }"
          :breakpoints="{ '640px': '95vw' }"
          class="resa-eleve-dialog"
        >
          <template #header>
            <div class="resa-eleve-banner">
              <div class="resa-eleve-banner-left">
                <span class="resa-eleve-banner-eleve">{{ eleveChoixResa ? eleveChoixResa.fullname : "Motif d'annulation du cours" }}</span>
                <span class="resa-eleve-banner-date">
                  Motif d'annulation du cours<template v-if="resaHeader"> · {{ resaHeader }}</template>
                </span>
              </div>
            </div>
          </template>
          <div class="d-body">
            <div class="d-field">
              <label class="d-label">Type de motif</label>
              <select name="typeMotf" id="typeMotf" v-model="motif.leTypeMotif" class="d-select" @change="prefillMotifCom">
                <option value="null">Saisir le type de motif</option>
                <template v-for="t in typeMotif" :key="t.id">
                  <option :value="t">{{ t.label }}</option>
                </template>
              </select>
            </div>

            <div class="d-field">
              <label class="d-label">Commentaire</label>
              <input type="text" class="d-input" placeholder="Saisir un commentaire" id="motifText" v-model="motif.com" />
            </div>

            <div class="d-actions">
              <button class="d-btn d-btn--ghost" @click="showEditModal">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                Modifier
              </button>
              <template v-if="motif.leTypeMotif != null && motif.com != ''">
                <button class="d-btn d-btn--primary" @click="setMotif" v-if="loadCancelResa == false">
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  Valider
                </button>
                <button class="d-btn d-btn--primary" @click="setMotif" v-if="loadCancelResa == true" disabled>
                  <i class="fa fa-spinner fa-spin"></i> Valider
                </button>
              </template>
              <template v-if="isSimuCourse">
                <button class="d-btn d-btn--primary" @click="terminerCoursSimu" v-if="loadTerminerCours == false">
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  Terminer le cours
                </button>
                <button class="d-btn d-btn--primary" v-else disabled>
                  <i class="fa fa-spinner fa-spin"></i> Terminer le cours
                </button>
              </template>
            </div>

            <template v-if="eleveChoixResa.setRdvpOrNot !== 'not' && eleveChoixResa.setRdvpOrNot !== 'setRdvp' && selectedEventRdvpEligible">
              <button class="d-btn d-btn--warning d-btn--block" @click="setRdvpOnApointment" v-if="loadSetRdvpButton === false">
                Transformer en {{ eleveChoixResa.setRdvpOrNot }}
              </button>
              <button class="d-btn d-btn--warning d-btn--block" v-else disabled>
                <i class="fa fa-spinner fa-spin"></i> Transformer en {{ eleveChoixResa.setRdvpOrNot }}
              </button>
            </template>
            <template v-if="eleveChoixResa.setRdvpOrNot === 'setRdvp' && selectedEventRdvpEligible">
              <button class="d-btn d-btn--danger d-btn--block" @click="setApointmentAsRdvp" v-if="loadSetApointmentAsRdvpButton === false">
                Faire de ce RDV le RDVP
              </button>
              <button class="d-btn d-btn--danger d-btn--block" v-else disabled>
                <i class="fa fa-spinner fa-spin"></i> Faire de ce RDV le RDVP
              </button>
            </template>
            <template v-if="selectedEventIsRdvp">
              <button class="d-btn d-btn--warning d-btn--block" @click="repasserEnCoursClassique" v-if="loadRepasserCoursClassiqueButton === false">
                Repasser en cours classique
              </button>
              <button class="d-btn d-btn--warning d-btn--block" v-else disabled>
                <i class="fa fa-spinner fa-spin"></i> Repasser en cours classique
              </button>
            </template>
          </div>
        </Dialog>

        <Dialog
          v-model:visible="popupEditCancel"
          modal
          header="Cours annulé"
          :style="{ width: '50rem', maxWidth: '98vw' }"
          :breakpoints="{ '640px': '95vw' }"
        >
          <div class="d-body">
            <div class="d-field">
              <label class="d-label">Type de motif</label>
              <select name="editTypeMotf" id="editTypeMotf" v-model="editMotif.leTypeMotif" class="d-select" @change="prefillEditMotifCom">
                <option value="null">Saisir le type de motif</option>
                <template v-for="t in typeMotif" :key="t.id">
                  <option :value="t">{{ t.label }}</option>
                </template>
              </select>
            </div>

            <div class="d-field">
              <label class="d-label">Commentaire</label>
              <input type="text" class="d-input" placeholder="Saisir un commentaire" id="editMotifText" v-model="editMotif.com" />
            </div>

            <div class="d-actions">
              <button class="d-btn d-btn--ghost" @click="popupEditCancel = false">Fermer</button>

              <button class="d-btn d-btn--danger" @click="remettreEnNormal" v-if="loadUncancelResa == false">
                Remettre le cours
              </button>
              <button class="d-btn d-btn--danger" v-else disabled>
                <i class="fa fa-spinner fa-spin"></i> Remettre le cours
              </button>

              <template v-if="editMotif.leTypeMotif != null && editMotif.com != ''">
                <button class="d-btn d-btn--primary" @click="saveEditMotif" v-if="loadEditMotif == false">
                  Enregistrer la modification
                </button>
                <button class="d-btn d-btn--primary" v-else disabled>
                  <i class="fa fa-spinner fa-spin"></i> Enregistrer la modification
                </button>
              </template>
            </div>
          </div>
        </Dialog>
      </div>
    </div>

    <Dialog v-model:visible="showExamDiag" modal header="EXAMEN" :style="{ width: '80rem' }">
      <CreateExam :planningResaE="this.planningResaE" showTab="false"/>    
    </Dialog>

    <Dialog v-model:visible="showExamBlancDiag" modal header="EXAMEN BLANC" :style="{ width: '80rem' }">
      <CreateExamBlanc :planningResaE="this.planningResaE" showTab="false"/>    
    </Dialog>

    <div class="split" :class="{ sidePlanning: this.$store.state.splitPage }" v-if="this.$store.state.splitPage === true">
      <button class="btn btn-secondary" @click="closeSplitWindow()" v-if="!splitViewHasOwnBanner">X</button>
      <div class="titleSplit">
        <h1 v-if="!splitViewHasOwnBanner">{{this.$store.state.titleSplit}}</h1>
        <Simulateur ref="refSimu" @putSelectEleve="setEleveHeader" @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'SIMULATEUR'"/>
        <DispoLieuEleve ref="refDispoLieu" @putSelectEleve="setEleveHeader" @close="closeSplitWindow" :moniteurs="this.moniteurs" v-if="this.$store.state.titleSplit === 'DISPO ELEVES'"/>
        <Aac ref="refAac" @putSelectEleve="setEleveHeader" @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'RDV AAC'"/>
        <HeureaProg ref="refHprog" @putSelectEleve="setEleveHeader" @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'H à pgmer'"/>
        <HeureEmargement @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'HEURE ET EMARGEMENT'"/>
        <CreateExam :planningResaE="this.planningResaE" showTab="true" @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'EXAM Ajout Elève'"/>
        <CreateExamBlanc :planningResaE="this.planningResaE" showTab="true" @close="closeSplitWindow" v-if="this.$store.state.titleSplit === 'EXAM BLANC Ajout Elève'"/>
      </div>

    </div>
  </div>

</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue3";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import MonoModal from "@/components/agence/planning/modals/MonoModal.vue";
import CreateExam from "@/components/agence/planning/modals/exam/CreateExam.vue";
import CreateExamBlanc from "@/components/agence/planning/modals/exam/CreateExamBlanc.vue";
import Simulateur from "@/components/agence/planning/split/Simulateur.vue";
import DispoLieuEleve from "@/components/agence/planning/split/DispoLieuEleve.vue";
import Aac from "@/components/agence/planning/split/Aac.vue";
import HeureaProg from "@/components/agence/planning/split/HeureaProg.vue";
import HeureEmargement from "@/components/agence/planning/split/HeureEmargement.vue";
import moment from "moment";
import { ref } from 'vue'

export default {

  setup(){
    const refSimu = ref();
    const refAac = ref();
    const refHprog = ref();
    const refDispoLieu = ref();
    const loadSimuEleves = () => refSimu.value.getStudentsSimu(0, "null");
    const loadHeureProgEleves = () => refHprog.value.getStudentHeureProg(0, "null");
    const loadElevesAac = () => refAac.value.refresh();
    const loadDispoEleves = () => refDispoLieu.value.refreshTable();
    return{
      refSimu,
      refAac,
      refHprog,
      refDispoLieu,
      loadSimuEleves,
      loadHeureProgEleves,
      loadElevesAac,
      loadDispoEleves
    }
  },

  props: [
    "eleves",
    "countEleves",
    "moniteurs",
    "getEleves",
    "getMoniteurs",
    "getMoniteursChange",
    "selectItemHeader",
    "refreshEleveHeader"
  ],
  components: {
    FullCalendar,
    MonoModal,
    Simulateur,
    DispoLieuEleve,
    Aac,
    HeureaProg,
    HeureEmargement,
    CreateExam,
    CreateExamBlanc
  },

  watch: {
    resaModal: function () {
      if (this.resaModal == false) {
        this.resetEleveResaSelection();
        this.lieuxMono = [];
        this.cbxAllStudents = false;
        this.cbxDispoOtherMono = false;
        this.showEleveDispo = true;
      }
    },
    showExamDiag: function () {
      if (this.showExamDiag == false) {
        window.location.reload();
      }
    },
    showExamBlancDiag: function () {
      if (this.showExamBlancDiag == false) {
        window.location.reload();
      }
    },
    "$store.state.splitPage": function () {
      this.$nextTick(() => {
        this.$refs.fullCalendar.getApi().updateSize();
      });
    },
  },

  data() {
    return {
      countElevesList: 0,
      loadSetRdvpButton : false,
      loadSetApointmentAsRdvpButton: false,
      loadRepasserCoursClassiqueButton: false,
      countElevesDispo: 0,
      lesEleves: [],
      apSimu: false,
      loadResaModalBtn: false,
      loadModifBtn: false,
      resaPopupEleve: false,
      motif: {
        leTypeMotif: null,
        com: "",
      },
      firstCours: false,
      boiteResa: null,
      firstCoursFin: [],
      popupMotif: false,
      typeMotif: [],
      showEleveDispo: true,
      eleveDispos: [],
      idEleveChoixResa: null,
      lieuDebChoix: null,
      lieuFinChoix: null,
      lieuxDeb: [],
      lieuxFin: null,
      prixHeure: 0,
      monoChoixResa: null,
      resaModal: false,
      hideSundayBtn: false,
      calendarOptions: {
        plugins: [timeGridPlugin, interactionPlugin, resourceTimeGridPlugin],
        initialView: "resourceTimeGridWeek",
        themeSystem: "bootstrap",
        selectable: true,
        nowIndicator: true,
        navLinks: true,
        firstDay: 1,
        allDaySlot: true,
        slotMinTime: "07:00:00",
        slotMaxTime: "21:00:00",
        slotDuration: "00:30:00",
        height: "auto",
        stickyHeaderDates: true,
        datesAboveResources: true,
        locale: "fr",
        timeZone: "local",
        editable: true,
        eventResizableFromStart: true,
        customButtons: {
          hideSunday: {
            text: "Dimanche",
            click: (e) => this.hideSundayMethod(e),
            background: "red",
          },
          prev: {
            text: "PREV",
            click: () => {
              this.todayBtnActive = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss"
              );
              if(this.dayWeekPlanning == false){
                  this.$emit("getMoniteursChange", date, false);
              }else{
                this.$emit("getMoniteursChange", date, true);
              }

              let resultIndispo = this.calendarOptions.events.filter(
                (e) => e.type != "indispo"
              );
              this.calendarOptions.events = resultIndispo;
            },
          },
          next: {
            text: "NEXT",
            click: () => {
              this.todayBtnActive = false;
              this.nextBtnPress = true;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss"
              );

              if(this.dayWeekPlanning == false){
                this.$emit("getMoniteursChange", date, false);
              }else{
                this.$emit("getMoniteursChange", date, true);
              }

              let resultIndispo = this.calendarOptions.events.filter(
                (e) => e.type != "indispo"
              );
              this.calendarOptions.events = resultIndispo;
            },
          },

          today: {
            text: "Aujourd'hui",
            click: () => {
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              if (this.calendarOptions.events != null) {
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.$emit("getMoniteursChange", moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.$emit("getMoniteursChange", date, true);
                }
              }

              calendarApi.today();
            },
          },

          resourceTimeGridDay: {
            text: "Jour",
            click: () => {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView("resourceTimeGridDay");
              calendarApi.today();
              this.dayWeekPlanning = false;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              if(this.calendarOptions.events != null){
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.$emit("getMoniteursChange", moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.$emit("getMoniteursChange", date, true);
                }
              }
            },
          },

          resourceTimeGridWeek: {
            text: "Semaine",
            click: () => {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView("resourceTimeGridWeek");
              calendarApi.today();
              this.dayWeekPlanning = true;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              if(this.calendarOptions.events != null){
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.$emit("getMoniteursChange", moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.$emit("getMoniteursChange", date, true);
                }
              }
            },
          },
        },
        headerToolbar: {
          start: "prev,next today",
          center: "title",
          end: "resourceTimeGridWeek,resourceTimeGridDay,hideSunday",
        },

        buttonText: {
          today: "Aujourd'hui",
          resourceTimeGridDay: "Jour",
          resourceTimeGridWeek: "Semaine",
          prev: "<",
          next: ">",
        },
        resources: [],
        resourceOrder: "title",
        selectAllow: this.selectAllow,
        select: this.selectEvent,
        eventClick: this.deleteEvent,
        eventContent: this.eventContent,
        eventDidMount: this.eventDidMount,
        eventResize: this.eventResizeIndispo,
        eventDrop: this.eventDropIndispo,
        events: [],
        hiddenDays: [],
        datesSet: this.addAllDayMessage,
      },
      moniteurchoix: [],
      tempAddedMonoIds: [],
      moniteursList: [],
      loadCalendar: 0,
      planningResaE: null,
      resaHeader: "",
      lieuPrevAp: [],
      eleveChoixResa: null,
      eleveChoixResaMonoSelect: false,
      loadCancelResa: false,
      loadTerminerCours: false,
      popupEditCancel: false,
      editMotif: { leTypeMotif: null, com: "" },
      loadEditMotif: false,
      loadUncancelResa: false,
      cancelledOverlap: null,
      loadReactivateOverlap: false,
      dayWeekPlanning: true,
      todayBtnActive : true,
      nextBtnPress : false,
      cbxAllStudents : false,
      cbxDispoOtherMono : false,
      dispoOtherMono : [],
      dispoThisMono : [],
      splitScreen : false,
      showExamDiag : false,
      showExamBlancDiag : false,
      lieuxMono : []
    };
  },

  mounted() {
    this.putOnPlanningApointment();
    this.choixMonoSaves();
    this.countElevesList = this.countEleves;
    this.lesEleves = this.eleves;
  },

  computed: {
    splitViewHasOwnBanner() {
      return [
        'SIMULATEUR',
        'DISPO ELEVES',
        'RDV AAC',
        'H à pgmer',
        'HEURE ET EMARGEMENT',
        'EXAM Ajout Elève',
        'EXAM BLANC Ajout Elève',
      ].includes(this.$store.state.titleSplit);
    },

    isSimuCourse() {
      if (!this.planningResaE || !this.planningResaE.event) {
        return false;
      }
      const resourceId = this.planningResaE.event._def.resourceIds[0];
      const resource = this.calendarOptions.resources.find((r) => r.id == resourceId);
      return resource ? resource.title === "Simu" : false;
    },

    cancelledOverlapRange() {
      if (!this.cancelledOverlap) {
        return "";
      }
      return moment(this.cancelledOverlap.start.date).format("HH:mm") + " - " + moment(this.cancelledOverlap.end.date).format("HH:mm");
    },

    prixBoiteResa() {
      if (!this.boiteResa || !this.prixHeure) {
        return null;
      }
      if (this.boiteResa === "BA") {
        return this.prixHeure.prixBa != null ? this.prixHeure.prixBa : null;
      }
      if (this.boiteResa === "BM") {
        return this.prixHeure.prixBm != null ? this.prixHeure.prixBm : null;
      }
      return null;
    },

    heuresProgrammeesList() {
      if (!this.eleveChoixResa) {
        return [];
      }
      return (this.eleveChoixResa.apointments || [])
        .filter((a) =>
          a.done === false &&
          a.cancelRdv === "null" &&
          a.moniteur.fullname !== "Le Simulateur" &&
          a.status !== "rdvp" && a.status !== "rdvp1" && a.status !== "rdvp2" &&
          new Date(a.start.date) > new Date()
        )
        .sort((a, b) => new Date(a.start.date) - new Date(b.start.date));
    },
    // Index (dans heuresProgrammeesList) du rdv après lequel le cumul d'heures programmées
    // atteint "H pour finir la formation" (heureRestanteTrame) : c'est la "fin théorique"
    heuresProgrammeesFinTheoriqueIndex() {
      if (!this.eleveChoixResa || this.eleveChoixResa.heureRestanteTrame == null) {
        // Pas de données de trame : on ne peut rien déterminer, aucun cours n'est éligible
        return Infinity;
      }
      if (this.eleveChoixResa.heureRestanteTrame <= 0) {
        // Formation déjà complète avant même de compter les cours à venir : tous sont "après le seuil"
        return -1;
      }
      let cumul = 0;
      const list = this.heuresProgrammeesList;
      for (let i = 0; i < list.length; i++) {
        const duree = (new Date(list[i].end.date) - new Date(list[i].start.date)) / 3600000;
        cumul += duree;
        if (cumul >= this.eleveChoixResa.heureRestanteTrame) {
          return i;
        }
      }
      // Jamais atteint même en cumulant tous les cours programmés : aucun cours n'est éligible
      return Infinity;
    },
    selectedEventRdvpEligible() {
      if (!this.planningResaE || !this.planningResaE.event) {
        return false;
      }
      const id = this.planningResaE["event"]["_def"]["publicId"];
      const idx = this.heuresProgrammeesList.findIndex((i) => String(i.id) === String(id));
      // Uniquement le tout dernier cours réservé après la fin théorique de formation : s'il y a
      // d'autres cours réservés après celui-ci, on ne propose pas de le transformer en RDVP (il ne
      // doit pas y avoir de cours "normal" après le RDVP).
      return idx !== -1 && idx > this.heuresProgrammeesFinTheoriqueIndex && idx === this.heuresProgrammeesList.length - 1;
    },
    // true si le cours cliqué est lui-même le RDV préalable (ou pédagogique 1/2) en cours
    selectedEventIsRdvp() {
      if (!this.planningResaE || !this.planningResaE.event) {
        return false;
      }
      const statutAac = this.planningResaE["event"]["_def"]["extendedProps"]["statutAac"];
      return statutAac === "rdvp" || statutAac === "rdvp1" || statutAac === "rdvp2";
    },
  },

  methods: {

    prefillMotifCom() {
      this.motif.com = this.motif.leTypeMotif != null ? this.motif.leTypeMotif.label : "";
    },

    prefillEditMotifCom() {
      this.editMotif.com = this.editMotif.leTypeMotif != null ? this.editMotif.leTypeMotif.label : "";
    },

    setApointmentAsRdvp(){
      this.loadSetApointmentAsRdvpButton = true;
      window.api
        .put(
          "/aac/apointment/setrdvp/" + this.planningResaE["event"]["_def"]["publicId"],
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          this.loadSetApointmentAsRdvpButton = false;
          alert("erreur");
        });
    },

    repasserEnCoursClassique(){
      if (!window.confirm("Voulez-vous repasser ce RDV préalable en cours classique ?")) {
        return;
      }
      this.loadRepasserCoursClassiqueButton = true;
      window.api
        .put(
          "/aac/apointment/resetrdvp/" + this.planningResaE["event"]["_def"]["publicId"],
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          this.loadRepasserCoursClassiqueButton = false;
          alert("erreur");
        });
    },

    setRdvpOnApointment(){
        this.loadSetRdvpButton = true;
        if (window.confirm("Voulez-vous passer ce RDV en " + this.eleveChoixResa.setRdvpOrNot)) {
          window.api
            .patch(
              "/apointments/" + this.planningResaE["event"]["_def"]["publicId"],
              {
                statutAac: this.eleveChoixResa.setRdvpOrNot,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                  "Content-Type": "application/merge-patch+json",
                },
              }
            )
            .then(() => {
              this.loadSetRdvpButton = false;
              window.location.reload();
            })
            .catch((error) => {
              console.log(error);
            });
        }
    },

    closeSplitWindow(){
      this.$store.commit('setSplitPage', false);
      this.$store.commit('setTitleSplit', "");
      if(this.$store.state.titleSplit === 'EXAM Ajout Elève' || this.$store.state.titleSplit === 'EXAM BLANC Ajout Elève'){
        window.location.reload();
      }
    },

    setEleveHeader(e){
      this.$emit("selectItemHeader", e);
    },

    addAllDayMessage() {
      this.$nextTick(() => {
        const allDayHeaders = document.querySelectorAll('td.fc-daygrid-day');

        allDayHeaders.forEach(a => {
            let monoAllDayId = a["attributes"]["data-resource-id"]["value"];

            if (this.$store.state.eleveSelectAgence != null){
              let findLeMono = false;
              if(this.$store.state.eleveSelectAgence["choixDispo"] != "null" || this.$store.state.eleveSelectAgence["choixDispo"] != null){
                this.$store.state.eleveSelectAgence["choixDispo"][0]["choix"].forEach(m => {
                  if(m.id == monoAllDayId){
                    findLeMono = true;
                  }
                })
              }

              if(findLeMono){
                a.style.backgroundColor = "rgba(0, 0, 255, 0.2)";
              }
            }
        })
      });
    },

    getBoiteForDay(moniteur, dateStr) {
      let override = (moniteur.changeBoite || []).find((c) => moment(c.day.date).format("YYYY-MM-DD") == dateStr);
      return {
        boite: override ? override.boite : moniteur.boite,
        changeBoiteId: override ? override.id : null,
      };
    },

    changeBoiteDay(e) {
      let resourceId = e["event"]["_def"]["resourceIds"][0];
      let moniteur = this.moniteurs.find((m) => m.idMono == resourceId);
      let isBoiteOverride = e["event"]["_def"]["extendedProps"]["isBoiteOverride"];
      let changeBoiteId = e["event"]["_def"]["extendedProps"]["changeBoiteId"];

      if (isBoiteOverride) {
        this.deleteChangeBoite(changeBoiteId, moniteur);
        return;
      }

      let currentBoite = e["event"]["_def"]["title"];
      let targetBoite = currentBoite == "BM" ? "BA" : "BM";
      let day = moment(e["event"]["start"]).format("YYYY-MM-DD");

      if (!window.confirm("Voulez-vous faire passer cette journée en " + targetBoite + " pour " + moniteur.fullname + " ?")) {
        return;
      }

      this.submitChangeBoite(moniteur, targetBoite, day, false);
    },

    submitChangeBoite(moniteur, targetBoite, day, force) {
      window.api
        .post(
          "/moniteur/" + moniteur.idMono + "/change-boite",
          {
            boite: targetBoite,
            day: day,
            force,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (force) {
            window.location.reload();
            return;
          }

          if (moniteur.changeBoite == null) {
            moniteur.changeBoite = [];
          }
          moniteur.changeBoite.push({
            id: response.data.id,
            boite: response.data.boite,
            day: response.data.day,
          });
          this.putOnPlanningApointment();
        })
        .catch((error) => {
          if (error.response && error.response.status === 409 && error.response.data.conflict) {
            if (window.confirm(error.response.data.message)) {
              this.submitChangeBoite(moniteur, targetBoite, day, true);
            }
            return;
          }
          console.log(error);
        });
    },

    deleteChangeBoite(changeBoiteId, moniteur) {
      if (!window.confirm("Voulez-vous annuler ce changement de boîte et revenir à la boîte par défaut de " + moniteur.fullname + " ?")) {
        return;
      }

      window.api
        .delete("/change-boite/" + changeBoiteId, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          moniteur.changeBoite = (moniteur.changeBoite || []).filter((c) => c.id != changeBoiteId);
          this.putOnPlanningApointment();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onPaginateDispo(e) {
      let offset = e.first;
      if(this.cbxAllStudents == false && this.cbxDispoOtherMono == false){
        window.api
          .post(
            "/eleves/agence/dispo/" +
              this.$store.state.user.agence.id +
              "/offset/"+offset+"/dispomono/true",
            {
              start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              mono: this.monoChoixResa,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.eleveDispos = [];
            response.data.eleves.forEach((eleve) => {
              this.eleveDispos.push(eleve);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }else if(this.cbxAllStudents == false && this.cbxDispoOtherMono == true){
        window.api
          .post(
            "/eleves/agence/dispo/" +
              this.$store.state.user.agence.id +
              "/offset/"+offset+"/dispomono/false",
            {
              start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              mono: this.monoChoixResa,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.eleveDispos = [];
            response.data.eleves.forEach((eleve) => {
              this.eleveDispos.push(eleve);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    onPaginate(e) {
      let offset = e.first;
      window.api
        .get(
          "/eleves/agence/planning/" +
            this.$store.state.user.agence.id +
            "/offset/" +
            offset,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.lesEleves = response.data.eleves;
          this.countElevesList = response.data.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    hideSundayMethod(e) {
      if (this.hideSundayBtn) {
        this.hideSundayBtn = false;
        e.target.style.background = "#2196f3";
        this.calendarOptions.hiddenDays = [];
      } else {
        this.hideSundayBtn = true;
        this.calendarOptions.hiddenDays = [0];
        e.target.style.background = "black";
      }
    },

    getLieuEleve(eleve) {
      this.eleveChoixResa = eleve;
      if (eleve.choixDispo != "null") {
        this.lieuxMono.forEach((l) => {
          eleve.choixDispo[0].choix.forEach((c) => {
            if (c.id == this.monoChoixResa) {
              this.eleveChoixResaMonoSelect = true;
            }
            if (c.lieux != undefined) {
              c.lieux.forEach((li) => {
                if (l.id == li) {
                  l.choixEleve = true;
                }
              });
            }
          });
        });
      }
      if (
        this.eleveChoixResa.boiteNom != this.boiteResa &&
        this.planningResaE["resource"]?.["_resource"]?.["title"] != "Simu"
      ) {
        alert("Ce moniteur roule en " + this.boiteResa + " sur ce créneau, veuillez choisir un élève utilisant la même boîte");
      }

      this.autoSelectLieux();
    },

    // Pré-remplit lieu de début/retour quand un seul choix est possible
    autoSelectLieux() {
      if (this.popupMotif == true) {
        return;
      }

      const debOptions = this.lieuxMono.filter(
        (l) => l.choixEleve == true || this.$store.state.user.agence.idl === l.id
      );
      this.lieuDebChoix = debOptions.length === 1 ? debOptions[0].id : null;

      const finOptions = this.lieuxMono.filter(
        (l) => l.choixEleve == true || this.$store.state.user.agence.idl === l.id || l.id == 1000
      );
      this.lieuFinChoix = finOptions.length === 1 ? finOptions[0].id : null;
    },

    // ─────────────────────────────────────────────────────────────
    // MODIFIÉ : eventDidMount — reconstruit le contenu de l'event
    // pour afficher les extendedProps (lieuDeb, lieuFin, statAac…)
    // ─────────────────────────────────────────────────────────────
    eventContent(info) {
      const { event, timeText } = info
      const props = event.extendedProps


      const enrichTypes = ['resa', 'exam', 'exam blanc', 'indispo', 'semainetype']
      if (!enrichTypes.includes(props.type)) return

      if (event.display === 'background' && props.type !== 'resa') return

      const inner = document.createElement('div')
      inner.className = 'ev-inner'

      const timeEl = document.createElement('div')
      timeEl.className = 'ev-time'
      timeEl.textContent = timeText
      inner.appendChild(timeEl)

      const titleEl = document.createElement('div')
      titleEl.className = 'ev-title'
      titleEl.textContent = event.title
      inner.appendChild(titleEl)

      if (props.type === 'exam' || props.type === 'exam blanc') {
        // ── Mise en page spécifique exam / exam blanc ──
        // RDV à [agence] (gras)
        if (props.rdv) {
          const rdvEl = document.createElement('div')
          rdvEl.className = 'ev-meta ev-meta-bold'
          rdvEl.textContent = 'RDV à ' + props.rdv
          rdvEl.dataset.priority = '2'
          inner.appendChild(rdvEl)
        }

        // Élèves inscrits (pas de préfixe "Eleves :")
        if (props.eleves) {
          const elevesEl = document.createElement('div')
          elevesEl.className = 'ev-meta'
          elevesEl.textContent = props.eleves
          elevesEl.dataset.priority = '2'
          inner.appendChild(elevesEl)
        }

        // Circuit (lieu)
        if (props.lieu) {
          const circuitEl = document.createElement('div')
          circuitEl.className = 'ev-meta'
          circuitEl.textContent = 'CIRCUIT : ' + props.lieu
          circuitEl.dataset.priority = '1'
          inner.appendChild(circuitEl)
        }
      } else {
        // Lieu début / fin : fusionnés en une seule ligne si identiques.
        // data-priority : ordre de suppression si la place manque (le plus petit d'abord).
        if (props.lieuDeb && props.lieuFin && props.lieuDeb === props.lieuFin) {
          const lieuDebFinEl = document.createElement('div')
          lieuDebFinEl.className = 'ev-meta'
          lieuDebFinEl.textContent = props.lieuDeb
          lieuDebFinEl.dataset.priority = '1'
          inner.appendChild(lieuDebFinEl)
        } else {
          if (props.lieuDeb) {
            const debEl = document.createElement('div')
            debEl.className = 'ev-meta'
            debEl.textContent = 'deb : ' + props.lieuDeb
            debEl.dataset.priority = '1'
            inner.appendChild(debEl)
          }
          if (props.lieuFin) {
            const finEl = document.createElement('div')
            finEl.className = 'ev-meta'
            finEl.textContent = 'fin : ' + props.lieuFin
            finEl.dataset.priority = '0'
            inner.appendChild(finEl)
          }
        }

        if (props.lieu) {
          const elieu = document.createElement('div')
          elieu.className = 'ev-meta'
          elieu.textContent = props.lieu
          elieu.dataset.priority = '1'
          inner.appendChild(elieu)
        }

        if (props.eleves) {
          const eleves = document.createElement('div')
          eleves.className = 'ev-meta'
          eleves.textContent = props.eleves
          eleves.dataset.priority = '2'
          inner.appendChild(eleves)
        }
      }

      // Motif d'annulation : gardé le plus longtemps possible (info la plus importante)
      if (props.motif && props.motif !== false) {
        const motifEl = document.createElement('div')
        motifEl.className = 'ev-motif'
        motifEl.textContent = '✕ ' + props.motif
        motifEl.dataset.priority = '3'
        inner.appendChild(motifEl)
      }

      // Badge statut AAC : sera repositionné en absolu (coin haut-droit) dans eventDidMount
      if (props.statutAac && props.statutAac !== 'null') {
        const aacEl = document.createElement('span')
        aacEl.className = 'ev-badge'
        aacEl.textContent = props.statutAac
        inner.appendChild(aacEl)
      }

      return { domNodes: [inner] }
    },

    eventDidMount(info) {
      const { event, el } = info
      const props = event.extendedProps

      let title = event.title
      if (props.type === 'exam' || props.type === 'exam blanc') {
        if (props.rdv) title += ' | RDV à ' + props.rdv
        if (props.eleves) title += ' | Élèves : ' + props.eleves
        if (props.mono) title += ' | Moniteur : ' + props.mono
        if (props.lieu) title += ' | CIRCUIT : ' + props.lieu
      } else {
        if (props.lieuDeb) title += ' | deb : ' + props.lieuDeb
        if (props.lieuFin) title += ' | fin : ' + props.lieuFin
        if (props.lieu) title += ' | lieu : ' + props.lieu
        if (props.eleves) title += ' | ' + props.eleves
      }
      if (props.motif && props.motif !== false) title += ' | Motif : ' + props.motif
      el.title = title

      // Le badge sort du flux normal pour être positionné en absolu dans le coin de l'event
      const badge = el.querySelector('.ev-badge')
      if (badge) {
        el.appendChild(badge)
      }

      // TEST SCROLL : trim désactivé le temps du test (on garde tout le contenu, on scroll à la place)
      const trimEnabled = false
      const trimQueue = Array.from(el.querySelectorAll('[data-priority]'))
        .sort((a, b) => Number(a.dataset.priority) - Number(b.dataset.priority))
      let guard = trimQueue.length
      while (trimEnabled && el.scrollHeight > el.clientHeight && trimQueue.length && guard > 0) {
        trimQueue.shift().remove()
        guard--
      }
    },

    getLesMoniteurs() {
      this.$emit("getMoniteurs");
    },

    choixMonoSaves() {
      window.api
        .get("/agence/choix/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.choix.length != 0) {
            this.$store.commit("setChoixSaveMono", response.data.choix[0]);
            this.choixSaveMono = response.data.choix[0];
            this.calendarOptions.resources = this.choixSaveMono.choix;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    diff_hours(dt2, dt1) {
      let diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60;
      return Math.abs(Math.round(diff));
    },

    buildCancelMailPayload(apointment) {
      let typeMotifLabel = this.motif.leTypeMotif ? this.motif.leTypeMotif.label : null;

      let payload = {
        type: "rdv annule",
        email: apointment.eleve ? apointment.eleve.email : null,
        typeMotif: typeMotifLabel,
        cas: null,
        start: apointment.start ? moment(apointment.start.date).format("YYYY-MM-DDTHH:mm:ss") : null,
        end: apointment.end ? moment(apointment.end.date).format("YYYY-MM-DDTHH:mm:ss") : null,
        lieuDebutNom: apointment.lieuDeb ? apointment.lieuDeb.nom : "",
        lieuFinNom: apointment.lieuFin ? apointment.lieuFin.nom : "",
        moniteurNom: "",
        moniteurPrenom: "",
      };

      if (apointment.moniteur) {
        let moniteur = this.moniteurs.find((m) => m.idMono == apointment.moniteur.idMoni);
        if (moniteur) {
          payload.moniteurNom = moniteur.nom;
          payload.moniteurPrenom = moniteur.prenom;
        }
      }

      if (typeMotifLabel === "Eleve Absent" && apointment.start) {
        let hDiff = this.diff_hours(new Date(apointment.start.date), new Date());
        payload.cas = hDiff <= 48 ? "moins48h" : "plus48h";
      }

      return payload;
    },

    // Retire en direct le badge RDVP d'un événement du calendrier quand le backend nous signale
    // qu'il vient d'être dé-programmé (suite à une annulation qui a fait remonter le besoin en
    // heures), pour ne pas avoir à recharger la page (F5) pour voir le changement.
    patchRdvpAnnuleEvent(rdvpAnnule) {
      if (!rdvpAnnule || !rdvpAnnule.id) {
        return;
      }
      const events = this.calendarOptions.events.map((e) => {
        if (String(e.id) === String(rdvpAnnule.id)) {
          return { ...e, statutAac: "null" };
        }
        return e;
      });
      this.calendarOptions = { ...this.calendarOptions, events };
    },

    buildCancelMailPayloadFromEvent() {
      let event = this.planningResaE["event"];
      let props = event["_def"]["extendedProps"];
      let resourceId = event["_def"]["resourceIds"][0];
      let moniteur = this.moniteurs.find((m) => m.idMono == resourceId);
      let typeMotifLabel = this.motif.leTypeMotif ? this.motif.leTypeMotif.label : null;

      let email = null;
      if (this.$store.state.eleveSelectAgence) {
        email = this.$store.state.eleveSelectAgence.email;
      } else if (props.eleveId) {
        let eleve = this.lesEleves.find((e) => e.id == props.eleveId);
        if (eleve) {
          email = eleve.email;
        }
      }

      let payload = {
        type: "rdv annule",
        email: email,
        typeMotif: typeMotifLabel,
        cas: null,
        start: moment(event.start).format("YYYY-MM-DDTHH:mm:ss"),
        end: moment(event.end).format("YYYY-MM-DDTHH:mm:ss"),
        lieuDebutNom: props.lieuDeb,
        lieuFinNom: props.lieuFin,
        moniteurNom: moniteur ? moniteur.nom : "",
        moniteurPrenom: moniteur ? moniteur.prenom : "",
      };

      if (typeMotifLabel === "Eleve Absent") {
        let hDiff = this.diff_hours(new Date(event.start), new Date());
        payload.cas = hDiff <= 48 ? "moins48h" : "plus48h";
      }

      return payload;
    },

    setMotif() {
      this.loadCancelResa = true;
      window.api
        .post(
          "/cancel/apointment/" +
            this.motif.leTypeMotif.id +
            "/" +
            this.planningResaE["event"]["_def"]["publicId"] +
            "/" +
            this.$store.state.user.id,
          {
            com: this.motif.com,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.loadCancelResa = false;
          this.$emit("getEleves");
          this.popupMotif = false;

          // Si cette annulation a fait remonter le besoin en heures et retiré le RDVP d'un autre
          // cours, on met à jour son badge directement (sans attendre un rechargement de page).
          this.patchRdvpAnnuleEvent(response.data.rdvpAnnule);

          if(this.$store.state.eleveSelectAgence != null){
            this.$emit("refreshEleveHeader", this.$store.state.eleveSelectAgence.id);
          }

          if(this.$store.state.titleSplit === 'SIMULATEUR'){
            this.loadSimuEleves();
          }else if(this.$store.state.titleSplit === 'RDV AAC'){
            this.loadElevesAac();
          }else if(this.$store.state.titleSplit === 'H à pgmer'){
            this.loadHeureProgEleves();
          }else if(this.$store.state.titleSplit === 'DISPO ELEVES'){
            this.loadDispoEleves();
          }

          if (response.data.apointment === "ok") {
            const mailPayload = this.buildCancelMailPayloadFromEvent();
            const id = this.planningResaE["event"]["_def"]["publicId"];
            const filter = this.calendarOptions.events.filter((a) => a.id != id);
            this.calendarOptions = { ...this.calendarOptions, events: filter };
            this.leTypeMotif = null;
            this.com = "";

            if (mailPayload.email) {
              window.api
                .post("/sendMail", mailPayload, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                })
                .then(() => {})
                .catch((error) => {
                  console.log(error);
                });
            }
            return;
          }

          if (response.data.apointment.typeMotif == "\tMono Absent") {
            response.data.apointment.typeMotif =
              response.data.apointment.typeMotif = "Mono Absent";
          }

          if (response.data.apointment.typeMotif == "Mono Absent") {
            // Ne plus afficher le rdv annulé, à la place on affiche l'indispo mono créée
            const filter = this.calendarOptions.events.filter((a) => a.id != response.data.apointment.id);
            if (response.data.apointment.indispoMono) {
              const i = response.data.apointment.indispoMono;
              filter.push({
                id: i.id,
                title: "INDISPO",
                start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#F3F2F2",
                textColor: "#5F5F5F",
                type: "indispo",
                motif: false,
                resourceId: i.moniteur.idMoni,
              });
            }
            this.calendarOptions = { ...this.calendarOptions, events: filter };
          } else if (response.data.apointment.typeMotif == "Incident") {
            const find = this.calendarOptions.events.find((a) => a.id == response.data.apointment.id);
            const filter = this.calendarOptions.events.filter((a) => a.id != response.data.apointment.id);
            if (find) {
              find.title = find.title + " - " + response.data.apointment.motif;
              find.motif = response.data.apointment.motif;
              find.color = "#fbbf24";
              find.textColor = "#431407";
              filter.push(find);
            }
            this.calendarOptions = { ...this.calendarOptions, events: filter };
          } else if (response.data.apointment.typeMotif == "Autre") {
            const filter = this.calendarOptions.events.filter((a) => a.id != response.data.apointment.id);
            this.calendarOptions = { ...this.calendarOptions, events: filter };
          } else if (response.data.apointment.typeMotif == "Eleve Absent") {
            const find = this.calendarOptions.events.find((a) => a.id == response.data.apointment.id);
            const filter = this.calendarOptions.events.filter((a) => a.id != response.data.apointment.id);
            if (find) {
              find.title = find.title + " - " + response.data.apointment.motif;
              find.motif = response.data.apointment.motif;
              find.color = "#fff1f2";
              find.textColor = "#be123c";
              find.display = "background";
              filter.push(find);
            }
            this.calendarOptions = { ...this.calendarOptions, events: filter };
          }

          this.leTypeMotif = null;
          this.com = "";

          window.api
            .post(
              "/sendMail",
              this.buildCancelMailPayload(response.data.apointment),
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            )
            .then(() => {})
            .catch((error) => {
              console.log(error);
            });

        })
        .catch((error) => {
          console.log(error);
        });
    },

    // Pour un cours sur simulateur : marque directement le rdv comme terminé
    // (équivalent du "Terminer le cours" côté moniteur), sans passer par le
    // parcours de synthèse pédagogique qui n'a pas de sens pour le simulateur.
    terminerCoursSimu() {
      this.loadTerminerCours = true;
      const id = this.planningResaE["event"]["_def"]["publicId"];
      const now = new Date();
      window.api
        .patch(
          "/apointments/" + id,
          {
            doneDate: now,
            done: true,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {
          this.loadTerminerCours = false;
          this.popupMotif = false;
          const filter = this.calendarOptions.events.map((e) => {
            if (e.id != id) return e;
            return {
              ...e,
              color: "#efebfe",
              textColor: "#794ac5",
              done: true,
            };
          });
          this.calendarOptions = { ...this.calendarOptions, events: filter };
          this.$emit("getEleves");

          if (this.$store.state.titleSplit === "SIMULATEUR") {
            this.loadSimuEleves();
          }
        })
        .catch((error) => {
          this.loadTerminerCours = false;
          console.log(error);
        });
    },

    // Modifie le motif/commentaire d'une annulation déjà appliquée (ex: mauvais commentaire
    // saisi). Rechargement de la page après succès pour refléter le changement, comme pour les
    // autres actions qui modifient l'état d'un cours sur ce planning.
    saveEditMotif() {
      this.loadEditMotif = true;
      const id = this.planningResaE["event"]["_def"]["publicId"];
      window.api
        .patch(
          "/apointment/motif/" + id + "/" + this.editMotif.leTypeMotif.id,
          {
            com: this.editMotif.com,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          this.loadEditMotif = false;
          console.log(error);
        });
    },

    // Annule l'annulation d'un cours (erreur de manipulation) : remet le rdv en normal.
    remettreEnNormal() {
      this.loadUncancelResa = true;
      const id = this.planningResaE["event"]["_def"]["publicId"];
      window.api
        .post(
          "/apointment/uncancel/" + id,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          this.loadUncancelResa = false;
          console.log(error);
        });
    },

    // Réactive le cours annulé détecté en chevauchement du créneau de réservation en cours
    // (voir selectEvent). Recharge la page : le créneau redevient occupé, donc la réservation
    // en cours n'a plus lieu d'être.
    reactivateOverlap() {
      this.loadReactivateOverlap = true;
      window.api
        .post(
          "/apointment/uncancel/" + this.cancelledOverlap.id,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          this.loadReactivateOverlap = false;
          console.log(error);
        });
    },

    // ─────────────────────────────────────────────────────────────
    // MODIFIÉ : les events "resa" stockent maintenant lieuDeb et
    // lieuFin dans des extendedProps dédiés (plus dans le title).
    // Le title ne contient plus que le nom de l'élève.
    // ─────────────────────────────────────────────────────────────
    putOnPlanningApointment() {

      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "resa");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "exam");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "exam blanc");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "boite");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "indispo");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "semainetype");
        this.calendarOptions.events = filterEvent;
      }
      if (this.calendarOptions.events.length != 0) {
        let filterEvent = this.calendarOptions.events.filter((e) => e.type != "boiteBadge");
        this.calendarOptions.events = filterEvent;
      }

      this.$store.state.moniteursPlanningAgence.forEach((e) => {
        e.apointments.forEach((r) => {
          if (r.lieuFin.nom == "Cer impérativement") {
            let fin = r.lieuFin.nom.substring(3);
            r.lieuFin.nom = this.$store.state.user.agence.nom + fin;
          } else if (
            r.lieuFin.nom == "CER ou lieu début selon les besoins de l'agence"
          ) {
            let fin = r.lieuFin.nom.substring(18);
            r.lieuFin.nom =
              this.$store.state.user.agence.nom +
              " ou " +
              r.lieuDeb.nom +
              " " +
              fin;
          }

          let statAac = "";
          if (r.statutAac != "null") {
            statAac = r.statutAac;
          }

          if (r.motif == "null") {
            if (r.done) {
              this.calendarOptions.events.push({
                id: r.id,
                // ↓ title simplifié : plus de lieux dans le titre
                title: r.eleve.fullname,
                start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#efebfe",
                textColor: "#794ac5",
                type: "resa",
                done: true,
                editable: false,
                motif: false,
                eleveId: r.eleve.id,
                resourceId: r.moniteur.idMoni,
                // ↓ extendedProps pour l'affichage dans eventDidMount
                lieuDeb: r.lieuDeb.nom,
                lieuFin: r.lieuFin.nom,
                statutAac: statAac,
              });
            } else {
              let color = "#d9f2e8";
              let textColor = "#065f46";
              if (r.eleve.boite == "BM") {
                color = "#fef3c7";
                textColor = "#b2743e";
              }

              this.calendarOptions.events.push({
                id: r.id,
                title: r.eleve.fullname,
                start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: color,
                textColor: textColor,
                type: "resa",
                done: false,
                editable: false,
                motif: false,
                eleveId: r.eleve.id,
                resourceId: r.moniteur.idMoni,
                // ↓ extendedProps
                lieuDeb: r.lieuDeb.nom,
                lieuFin: r.lieuFin.nom,
                statutAac: statAac,
              });
            }
          } else {
            if (r.typeMotif == "Eleve Absent") {
              let hDiff = this.diff_hours(
                new Date(r.start.date),
                new Date(r.cancelRdv.date)
              );

              if (hDiff <= 48) {
                this.calendarOptions.events.push({
                  id: r.id,
                  title: r.eleve.fullname,
                  start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                  end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                  color: "#fff1f2",
                  textColor: "#be123c",
                  type: "resa",
                  done: false,
                  editable: false,
                  motif: r.motif || false,
                  eleveId: r.eleve.id,
                  display: "background",
                  resourceId: r.moniteur.idMoni,
                  lieuDeb: r.lieuDeb.nom,
                  lieuFin: r.lieuFin.nom,
                  statutAac: statAac,
                });
              }
            } else if (r.typeMotif == "Mono Absent") {
              // Ne plus afficher les rdvs annulés avec le motif "Mono Absent"
            } else if (r.typeMotif == "Incident") {
              this.calendarOptions.events.push({
                id: r.id,
                title: r.eleve.fullname,
                start: moment(r.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(r.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#fbbf24",
                textColor: "#431407",
                type: "resa",
                done: false,
                editable: false,
                eleveId: r.eleve.id,
                motif: r.motif || false,
                resourceId: r.moniteur.idMoni,
                lieuDeb: r.lieuDeb.nom,
                lieuFin: r.lieuFin.nom,
                statutAac: statAac,
              });
            }
          }
        });

        e.indispo.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "INDISPO",
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "#F3F2F2",
            textColor: "#5F5F5F",
            type: "indispo",
            motif: false,
            resourceId: i.moniteur.idMoni,
          });
        });

        e.indispoSemaineType.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "INDISPO",
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "#F3F2F2",
            textColor: "#5F5F5F",
            type: "semainetype",
            motif: false,
            resourceId: i.moniteur.idMoni,
          });
        });

        if (e.boite && e.surnom !== "Simu") {
          const calDate = new Date(this.$refs.fullCalendar.getApi().getDate());
          const todayDay = calDate.getDay();
          const monday = new Date(calDate);
          monday.setDate(calDate.getDate() + (todayDay === 0 ? -6 : 1 - todayDay));

          for (let i = 0; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            const dateStr = moment(day).format("YYYY-MM-DD");
            const { boite: dayBoite, changeBoiteId } = this.getBoiteForDay(e, dateStr);

            this.calendarOptions.events.push({
              id: "boiteBadge-" + e.idMono + "-" + dateStr,
              title: dayBoite,
              start: dateStr,
              allDay: true,
              color: dayBoite == "BM" ? "#fef3c7" : "#d9f2e8",
              textColor: dayBoite == "BM" ? "#b2743e" : "#065f46",
              type: "boiteBadge",
              isBoiteOverride: changeBoiteId != null,
              changeBoiteId: changeBoiteId,
              editable: false,
              resourceId: e.idMono,
            });
          }
        }

        e.exams.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "EXAM : " + i.boite,
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "#FFDCE2",
            textColor: "#FF92A4",
            type: "exam",
            lieu: i.lieu.nom ,
            eleves: i.eleves.map((el) => el.nom).join(', '),
            mono: i.moniteur.surnom,
            rdv: this.$store.state.user.agence.nom,
            resourceId: i.moniteur.idMoni,
          });
        });

        e.examBlanc.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "EXAM BLANC : " + i.boite,
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "orange",
            type: "exam blanc",
            lieu: i.lieu.nom ,
            eleves: i.eleves.map((el) => el.nom).join(', '),
            mono: i.moniteur.surnom,
            rdv: this.$store.state.user.agence.nom,
            resourceId: i.moniteur.idMoni,
          });
        });

        e.params.forEach((i) => {
            // Snapshot sans mutation : on clone calDate avant chaque setDate
            const calDate  = new Date(this.$refs.fullCalendar.getApi().getDate());
            const todayDay = calDate.getDay();

            const iStartDay = new Date(i.start).getDay();
            const iEndDay   = new Date(i.end).getDay();

            const diffStart = calDate.getDate() - todayDay + (todayDay === 0 ? -6 : iStartDay);
            const diffEnd   = calDate.getDate() - todayDay + (todayDay === 0 ? -6 : iEndDay);

            // Clones indépendants pour éviter la mutation de calDate
            const startDate = new Date(calDate);
            startDate.setDate(diffStart);
            if (iStartDay === 0) startDate.setDate(startDate.getDate() + 7);

            const endDate = new Date(calDate);
            endDate.setDate(diffEnd);
            if (iEndDay === 0) endDate.setDate(endDate.getDate() + 7);

            // Chaque date génère son propre yyyy-mm-dd (correct en cas de changement de mois)
            const fmtDate = (d, timePart) => {
              const dd   = String(d.getDate()).padStart(2, "0");
              const mm   = String(d.getMonth() + 1).padStart(2, "0");
              const yyyy = d.getFullYear();
              return `${yyyy}-${mm}-${dd}T${timePart}`;
            };

            const start = fmtDate(startDate, i.start.split("T")[1]);
            const end   = fmtDate(endDate,   i.end.split("T")[1]);

            if (i.title === "INDISPO") {
              this.calendarOptions.events.push({
                id: i.id,
                title: "INDISPO",
                start: moment(start).format("YYYY-MM-DDTHH:mm:ss"),
                end:   moment(end).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#CCCCCC",
                textColor: "#494949FF",
                type: "boite",
                motif: false,
                resourceId: e.idMono,
              });
            }
          });
      });
    },

    resetEleveResaSelection() {
      this.idEleveChoixResa = null;
      this.eleveChoixResa = null;
      this.lieuDebChoix = null;
      this.lieuFinChoix = null;
    },

    getDispoElevesOtherMono(e){
      this.resetEleveResaSelection();
      if (e.target.checked) {
        this.showEleveDispo = true;
        this.cbxAllStudents = false;
        window.api
          .post(
            "/eleves/agence/dispo/" +
              this.$store.state.user.agence.id +
              "/offset/0/dispomono/false",
            {
              start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              mono: this.monoChoixResa,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.eleveDispos = [];
            response.data.eleves.forEach((eleve) => {
              this.eleveDispos.push(eleve);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.fetchEleveDispoThisMono();
      }
    },

    fetchEleveDispoThisMono() {
      window.api
        .post(
          "/eleves/agence/dispo/" +
            this.$store.state.user.agence.id +
            "/offset/0/dispomono/true",
          {
            start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            mono: this.monoChoixResa,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.eleveDispos = [];
          response.data.eleves.forEach((eleve) => {
            this.eleveDispos.push(eleve);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllEleves(e) {
      this.resetEleveResaSelection();
      if (e.target.checked) {
        this.showEleveDispo = false;
        this.cbxDispoOtherMono = false;
      } else {
        this.showEleveDispo = true;
        this.fetchEleveDispoThisMono();
      }
    },

    addMissingEleveMonos(eleve) {
      if (!eleve || eleve["choixDispo"] == "null" || eleve["choixDispo"] == null) return;
      let choix = eleve["choixDispo"][0]["choix"];
      if (!choix) return;

      let aAjouter = [];
      choix.forEach(c => {
        let dejaPresent = this.calendarOptions.resources.find(r => r.id == c.id);
        if (!dejaPresent) {
          let moniteurFind = this.moniteurs.find(m => m.idMono == c.id);
          if (moniteurFind && !aAjouter.find(r => r.id == moniteurFind.idMono)) {
            aAjouter.push({ title: moniteurFind.surnom, id: moniteurFind.idMono });
          }
        }
      });

      if (aAjouter.length > 0) {
        this.calendarOptions.resources = [...this.calendarOptions.resources, ...aAjouter];
        this.tempAddedMonoIds = [...this.tempAddedMonoIds, ...aAjouter.map(r => r.id)];
      }
    },

    removeTempAddedMonos() {
      if (this.tempAddedMonoIds.length == 0) return;
      this.calendarOptions.resources = this.calendarOptions.resources.filter(
        r => !this.tempAddedMonoIds.includes(r.id)
      );
      this.tempAddedMonoIds = [];
    },

    displayDispo(eleve) {
      this.addMissingEleveMonos(eleve);
      const allDayHeaders = document.querySelectorAll('td.fc-daygrid-day');
      allDayHeaders.forEach(a => {
          let monoAllDayId = a["attributes"]["data-resource-id"]["value"];
          let findMono = false;
          if(eleve["choixDispo"] != "null" || eleve["choixDispo"] != null){
            eleve["choixDispo"][0]["choix"].forEach(m => {
              if(m.id == monoAllDayId){
                findMono = true;
              }
            })
          }

          if(findMono){
            a.style.backgroundColor = "rgba(0, 0, 255, 0.2)";
          }
      })

      this.calendarOptions.events = this.calendarOptions.events.filter((e) => e.type !== "dispo");

      if (this.$store.state.selectedDispoSlot != null) {
        // Vient d'un clic sur une ligne du tableau "DISPO ELEVES" : on n'affiche que ce créneau-là
        const slot = this.$store.state.selectedDispoSlot;
        this.calendarOptions.events.push({
          id: "dispo-selected-" + eleve.id,
          title: "Dispo " + eleve.nom + " " + eleve.prenom,
          start: slot.start,
          end: slot.end,
          color: "blue",
          type: "dispo",
        });
        this.$store.commit('setSelectedDispoSlot', null);
      } else {
        eleve.dispos.forEach((d) => {
          this.calendarOptions.events.push({
            id: d.id,
            title: "Dispo "+eleve.nom +" "+eleve.prenom+" : " + d.lieu,
            start: moment(d.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(d.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "blue",
            type: "dispo",
          });
        });
      }
    },

    changeDisplayApointment(display) {
      let dispos = [];
      let apointments = [];
      let indispos = [];
      let semaineType = [];
      let boite = [];
      let exam = [];
      let examBlanc = [];
      let boiteBadge = [];

      this.calendarOptions.events.forEach((di) => {
        if (di.type == "dispo") dispos.push(di);
        if (di.type == "resa") apointments.push(di);
        if (di.type == "indispo") indispos.push(di);
        if (di.type == "semainetype") semaineType.push(di);
        if (di.type == "boite") boite.push(di);
        if (di.type == "exam") exam.push(di);
        if (di.type == "exam blanc") examBlanc.push(di);
        if (di.type == "boiteBadge") boiteBadge.push(di);
      });

      if (display) {
        this.calendarOptions.events = [];

        if (this.$store.state.eleveSelectAgence != null) {
          if(this.$store.state.eleveSelectAgence.choixDispo[0]["choix"] !== undefined){
            this.$store.state.eleveSelectAgence.choixDispo[0]["choix"].forEach(
              (e) => {
                dispos.forEach((d) => {
                  this.calendarOptions.events.push({
                    id: d.id,
                    title: d.title,
                    start: d.start,
                    end: d.end,
                    color: d.color,
                    type: d.type,
                    display: "background",
                    resourceId: e.id,
                  });
                });
              }
            );
          }
        }

        apointments.forEach((r) => {
          if(r.color === "#fff1f2"){
            this.calendarOptions.events.push({
              id: r.id,
              title: r.title,
              start: r.start,
              end: r.end,
              color: r.color,
              textColor: r.textColor,
              type: r.type,
              done: r.done,
              editable: r.editable,
              motif: r.motif,
              display: "background",
              resourceId: r.resourceId,
              eleveId: r.eleveId,
              lieuDeb: r.lieuDeb,
              lieuFin: r.lieuFin,
              statutAac: r.statutAac,
            });
          }else{
            this.calendarOptions.events.push({
              id: r.id,
              title: r.title,
              start: r.start,
              end: r.end,
              color: r.color,
              textColor: r.textColor,
              type: r.type,
              done: r.done,
              editable: r.editable,
              motif: r.motif,
              resourceId: r.resourceId,
              eleveId: r.eleveId,
              lieuDeb: r.lieuDeb,
              lieuFin: r.lieuFin,
              statutAac: r.statutAac,
            });
          }
        });

        exam.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, lieu: r.lieu, eleves: r.eleves });
        });
        examBlanc.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, lieu: r.lieu, eleves: r.eleves });
        });
        indispos.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, motif: false });
        });
        semaineType.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, motif: false });
        });
        boite.forEach((d) => {
          if (d.title == "INDISPO") {
            this.calendarOptions.events.push({ id: d.id, title: d.title, start: d.start, end: d.end, color: d.color, textColor: d.textColor, type: d.type, resourceId: d.resourceId, motif: false });
          } else {
            this.calendarOptions.events.push({ id: d.id, title: d.title, start: d.start, end: d.end, color: d.color, type: d.type, resourceId: d.resourceId, display: "background" });
          }
        });
        boiteBadge.forEach((d) => {
          this.calendarOptions.events.push({ id: d.id, title: d.title, start: d.start, allDay: d.allDay, color: d.color, textColor: d.textColor, type: d.type, isBoiteOverride: d.isBoiteOverride, changeBoiteId: d.changeBoiteId, editable: false, resourceId: d.resourceId });
        });
      } else {
        this.calendarOptions.events = [];
        indispos.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, motif: false });
        });
        semaineType.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, motif: false });
        });
        boiteBadge.forEach((d) => {
          this.calendarOptions.events.push({ id: d.id, title: d.title, start: d.start, allDay: d.allDay, color: d.color, textColor: d.textColor, type: d.type, isBoiteOverride: d.isBoiteOverride, changeBoiteId: d.changeBoiteId, editable: false, resourceId: d.resourceId });
        });
        exam.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, lieu: r.lieu, eleves: r.eleves });
        });
        examBlanc.forEach((r) => {
          this.calendarOptions.events.push({ id: r.id, title: r.title, start: r.start, end: r.end, color: r.color, textColor: r.textColor, type: r.type, resourceId: r.resourceId, lieu: r.lieu, eleves: r.eleves });
        });
        dispos.forEach((d) => {
          this.calendarOptions.events.push({ id: d.id, title: d.title, start: d.start, end: d.end, color: "blue", type: d.type });
        });
        apointments.forEach((r) => {
          this.calendarOptions.events.push({
            id: r.id, title: r.title, start: r.start, end: r.end,
            color: r.color, type: r.type, textColor: r.textColor, done: r.done, editable: r.editable,
            motif: r.motif, resourceId: r.resourceId, display: "background",
            lieuDeb: r.lieuDeb, lieuFin: r.lieuFin, statutAac: r.statutAac,
          });
        });
      }
    },

    getFonctionnalite() {
      window.api
        .get("/fonctionnalites/4", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.prixHeure = response.data.montant;
        })
        .catch((error) => { console.log(error); });
    },

    deleteEvent(e) {
      this.planningResaE = e;

      if (e["event"]["_def"]["extendedProps"]["type"] == "boiteBadge") {
        this.changeBoiteDay(e);
      } else if (e["event"]["_def"]["extendedProps"]["type"] == "indispo" && e["event"]["_def"]["ui"]["backgroundColor"] == "#F3F2F2") {
        window.api
          .delete("/indisponibilites/" + e["event"]["_def"]["publicId"], {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then(() => {
            let events = [];
            this.calendarOptions.events.forEach((i) => {
              if (i.id != e["event"]["_def"]["publicId"]) events.push(i);
            });
            this.calendarOptions.events = events;
          })
          .catch((error) => { console.log("ERRR::", error.response.data); });
      } else if (e["event"]["_def"]["extendedProps"]["type"] == "semainetype") {
        window.api
          .delete("/indispo-semaine-type/" + e["event"]["_def"]["publicId"], {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then(() => {
            let events = [];
            this.calendarOptions.events.forEach((i) => {
              if (i.id != e["event"]["_def"]["publicId"]) events.push(i);
            });
            this.calendarOptions.events = events;
          })
          .catch((error) => { console.log("ERRR::", error.response.data); });
      } else if (e["event"]["_def"]["extendedProps"]["type"] == "dispo") {
        window.api
          .delete("/disponibilites/" + e["event"]["_def"]["publicId"], {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then(() => {
            let events = this.calendarOptions.events.filter((i) => {
              i.id != e["_def"]["publicId"];
            });
            this.calendarOptions.events = events;
          })
          .catch((error) => { console.log("ERRR::", error.response.data); });
      } else if (
        e["event"]["_def"]["extendedProps"]["type"] == "resa" &&
        e["event"]["_def"]["extendedProps"]["motif"] == false &&
        e["event"]["_def"]["extendedProps"]["done"] == false
      ) {
        window.api
          .get("/type_motifs", {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((response) => {
            window.api
              .get(
                "/eleves/agence/planning/selec/" +
                  e["event"]["_def"]["extendedProps"]["eleveId"],
                {
                  headers: { Authorization: "Bearer " + this.$store.state.token },
                }
              )
              .then((r) => {
                let eleve = r.data.eleves[0];
                this.eleveChoixResa = eleve;
                this.typeMotif = response.data["hydra:member"];
                this.resaHeader =
                  moment(e.event.start).format("ddd DD/MM/YY - HH") +
                  "h" + moment(e.event.start).format("mm") +
                  " - " + moment(e.event.end).format("HH") +
                  "h" + moment(e.event.end).format("mm");
                this.popupMotif = true;
              })
              .catch((error) => { console.log(error); });
          })
          .catch((error) => { console.log(error); });
      } else if (
        e["event"]["_def"]["extendedProps"]["type"] == "resa" &&
        e["event"]["_def"]["extendedProps"]["motif"] != false &&
        e["event"]["_def"]["extendedProps"]["done"] == false
      ) {
        // Cours déjà annulé (ex: motif "Incident", toujours affiché comme bloc normal sur le
        // planning) : permet de modifier le motif, ou de remettre le cours en normal en cas
        // d'erreur d'annulation.
        window.api
          .get("/type_motifs", {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((response) => {
            this.typeMotif = response.data["hydra:member"];
            this.editMotif.leTypeMotif = null;
            this.editMotif.com = e["event"]["_def"]["extendedProps"]["motif"] || "";
            this.popupEditCancel = true;
          })
          .catch((error) => { console.log(error); });
      }else if(e["event"]["_def"]["extendedProps"]["type"] == "exam"){
        this.$store.commit('setSplitPage', true);
        this.$store.commit('setTitleSplit', "EXAM Ajout Elève");
      }else if(e["event"]["_def"]["extendedProps"]["type"] == "exam blanc"){
        this.$store.commit('setSplitPage', true);
        this.$store.commit('setTitleSplit', "EXAM BLANC Ajout Elève");
      }
    },

    showEditModal() {
      const props = this.planningResaE["event"]["_def"]["extendedProps"];
      this.lieuPrevAp = [' ' + props.lieuDeb, props.lieuFin];
      this.monoChoixResa =
        this.planningResaE["event"]["_def"]["resourceIds"][0];
      window.api
        .get(
          "/eleves/agence/planning/selec/" +
            this.planningResaE["event"]["_def"]["extendedProps"]["eleveId"],
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          }
        )
        .then((response) => {
          let mono = this.moniteurs.find((e) => e.idMono == this.monoChoixResa);
          this.lieuxMono = mono.lieux.filter((e) => e.get == true).map(l => ({ ...l, choixEleve: false }));
          const dateStr = moment(
            this.planningResaE["event"]["_instance"]["range"]["start"]
          ).format("YYYY-MM-DD");
          this.boiteResa = this.getBoiteForDay(mono, dateStr).boite;
          let student = response.data.eleves[0];
          this.getLieuEleve(student);
          this.resaHeader =
            "Modification : " +
            this.planningResaE["event"]["_def"]["title"];
          this.resaPopupEleve = true;
          this.popupMotif = true;
        })
        .catch((error) => { console.log(error); });
    },

    cancelEleveChoix() {
      let filter = [];
      this.calendarOptions.events.forEach((a) => {
        if (a.type != "dispo") filter.push(a);
      });
      this.calendarOptions.events = filter;

      const allDayHeaders = document.querySelectorAll('td.fc-daygrid-day');
      allDayHeaders.forEach(a => { a.style.backgroundColor = ""; })

      this.removeTempAddedMonos();
    },

    putApointment() {
      this.loadModifBtn = true;
      window.api
        .put(
          "/apointment/" + this.planningResaE["event"]["_def"]["publicId"],
          {
            lieu: this.lieuDebChoix,
            lieuFin: this.lieuFinChoix,
          },
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          }
        )
        .then((response) => {
          let filter = [];
          this.calendarOptions.events.forEach((a) => {
            if (a.id != response.data.apointment.id) filter.push(a);
          });
          this.calendarOptions.events = filter;

          let color = "#d9f2e8";
          let textColor = "#065f46";
          if (response.data.apointment.eleve.boite == "BM") {
            color = "#fef3c7";
            textColor = "#b2743e";
          }

          let statAac = "";
          if (response.data.apointment.statutAac != "null") {
            statAac = response.data.apointment.statutAac;
          }

          this.calendarOptions.events.push({
            id: response.data.apointment.id,
            title: response.data.apointment.eleve.fullname,
            start: moment(response.data.apointment.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(response.data.apointment.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: color,
            textColor: textColor,
            type: "resa",
            eleveId: response.data.apointment.eleve.id,
            done: false,
            editable: false,
            motif: false,
            resourceId: response.data.apointment.moniteur.idMoni,
            // ↓ extendedProps mis à jour après modification
            lieuDeb: response.data.apointment.lieuDeb.nom,
            lieuFin: response.data.apointment.lieuFin.nom,
            statutAac: statAac,
          });

          this.popupMotif = false;
          this.resaPopupEleve = false;
          this.loadModifBtn = false;

          window.api
            .get("/mail/change/resa/eleve/"+response.data.apointment.id, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {})
            .catch((error) => { console.log(error); });
        })
        .catch((error) => { console.log(error); });
    },

    setApointment() {
      this.loadResaModalBtn = true;
      let eleve = null;

      if (this.$store.state.eleveSelectAgence != null) {
        eleve = this.$store.state.eleveSelectAgence.id;
      } else {
        eleve = this.idEleveChoixResa;
      }

      window.api
        .post(
          "/rdv/check",
          {
            start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            idMono: this.monoChoixResa,
          },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then((checkResponse) => {
          if (checkResponse.data.cani === false) {
            alert("Ce créneau n'est plus disponible pour ce moniteur (cours ou indisponibilité existant sur cette plage horaire).");
            this.loadResaModalBtn = false;
            return;
          }
          this.setApointmentAfterCheck(eleve);
        })
        .catch((error) => {
          console.log(error);
          this.loadResaModalBtn = false;
        });
    },

    setApointmentAfterCheck(eleve) {
      let cantSimu = false;

      window.api
        .post(
          "/eleves/cansimu/" + eleve,
          {
            start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            mono: this.monoChoixResa,
          },
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          }
        )
        .then((response) => {
          cantSimu = response.data.eleves[0].nbRdv;
          const _pushResaEvent = (data) => {
              let color = "#d9f2e8";
              let textColor = "#065f46";
              if (data.boite == "BM") {
                color = "#fef3c7";
                textColor = "#b2743e";
              }

            let statAac = "";
            if (data.statutAac != "null") statAac = data.statutAac;

            if(this.$store.state.eleveSelectAgence != null){
              this.$emit("refreshEleveHeader", this.$store.state.eleveSelectAgence.id);
            }
            if(this.$store.state.titleSplit === 'SIMULATEUR'){
              this.loadSimuEleves();
            }else if(this.$store.state.titleSplit === 'RDV AAC'){
              this.loadElevesAac();
            }else if(this.$store.state.titleSplit === 'H à pgmer'){
              this.loadHeureProgEleves();
            }else if(this.$store.state.titleSplit === 'DISPO ELEVES'){
              this.loadDispoEleves();
            }

            this.calendarOptions.events.push({
              id: data.apointment,
              title: data.eleve,
              start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              color: color,
              textColor: textColor,
              type: "resa",
              done: false,
              editable: false,
              motif: false,
              eleveId: eleve,
              resourceId: this.monoChoixResa,
              // ↓ extendedProps depuis la réponse API
              lieuDeb: data.deb,
              lieuFin: data.fin,
              statutAac: statAac,
            });

            this.$emit("getEleves");
            if (this.$store.state.eleveSelectAgence != null) {
              this.resaPopupEleve = false;
            } else {
              this.resaModal = false;
            }
            this.lieuxMono = [];
            this.lieuFinChoix = null;
            this.loadResaModalBtn = false;
            this.idEleveChoixResa = null;

            window.api.post("/sendMail",
              { type: "rdv ok", id: data.apointment, email: data.eleveMail },
              { headers: { Authorization: "Bearer " + this.$store.state.token } }
            ).then(() => {}).catch((error) => { console.log(error); });
          }

          const _doSetApointment = () => {
            window.api
              .post(
                "/set/apointment/" + eleve + "/" + this.monoChoixResa + "/" + this.lieuDebChoix + "/" + this.lieuFinChoix,
                {
                  start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
                  end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
                },
                { headers: { Authorization: "Bearer " + this.$store.state.token } }
              )
              .then((response) => {
                if (response.data.message == "Solde insufisant") {
                  alert("Le solde de l'élève selectioné est insufisant");
                  this.loadResaModalBtn = false;
                } else if (response.data.message == "created") {
                  _pushResaEvent(response.data);
                } else {
                  alert(response.data.message);
                  this.loadResaModalBtn = false;
                }
              })
              .catch((error) => { console.log(error); });
          }

          if (cantSimu == false || cantSimu <= 0) {
            _doSetApointment();
          } else {
            if (this.apSimu == false) {
              let alertMsg = "";
              let nbHeure = "4";
              if (cantSimu == "not") {
                alertMsg = "Vous ne pouvez pas réserver un cours avec un moniteur avant que les "+nbHeure+" heures obligatoires sur simulateur pour cet élève soient effectuées";
              } else {
                alertMsg = "Cet élève doit faire "+nbHeure+"h de simulateur minimum avant de pouvoir conduire avec un moniteur (" + cantSimu + "h restantes)";
              }
              alert(alertMsg);
              if (this.$store.state.eleveSelectAgence != null) {
                this.resaPopupEleve = false;
              } else {
                this.resaModal = false;
              }
              this.lieuxMono = [];
              this.lieuFinChoix = null;
              this.loadResaModalBtn = false;
              this.idEleveChoixResa = null;
            } else {
              _doSetApointment();
            }
          }
        })
        .catch((error) => { console.log(error); });
    },

    selectEvent(e) {
      this.planningResaE = e;
      this.monoChoixResa = e["resource"]["_resource"]["id"];

      if (this.$store.state.planningSelectChoice == "INDISPO") {
        this.setIndispo(e);
      } else if (this.$store.state.planningSelectChoice == "DISPO") {
        this.setDispo(e);
      } else if (this.$store.state.planningSelectChoice == "RESA" && !e.allDay) {
        // Prévient le double-booking accidentel : si un cours a été annulé (ex: Elève Absent)
        // sur un créneau qui chevauche celui qu'on sélectionne, on le signale avec un moyen de
        // le réactiver directement, au cas où l'annulation était une erreur.
        this.cancelledOverlap = null;
        window.api
          .get(
            "/apointment/cancelled-overlap/" + this.monoChoixResa +
              "?start=" + moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss") +
              "&end=" + moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            { headers: { Authorization: "Bearer " + this.$store.state.token } }
          )
          .then((response) => {
            this.cancelledOverlap = response.data.apointments.length > 0 ? response.data.apointments[0] : null;
          })
          .catch((error) => { console.log(error); });

        window.api
          .post(
            "/eleves/agence/dispo/" + this.$store.state.user.agence.id + "/offset/0/dispomono/true",
            {
              start: moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              mono: this.monoChoixResa,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } }
          )
          .then((response) => {
            this.eleveDispos = [];
            response.data.eleves.forEach((eleve) => { this.eleveDispos.push(eleve); });
          })
          .catch((error) => { console.log(error); });

        window.api
          .get("/prix/conduite", { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((response) => {
            this.prixHeure = response.data;

            if (e["resource"]["_resource"]["title"] === "Simu") {
              this.apSimu = true;
            } else {
              this.apSimu = false;
            }

            if (this.$store.state.eleveSelectAgence != null) {
              this.eleveChoixResa = this.$store.state.eleveSelectAgence;
              this.resaPopupEleve = true;
              this.resaHeader =
                moment(this.planningResaE.startStr).format("ddd DD/MM/YY - HH") +
                "h" + moment(this.planningResaE.startStr).format("mm") +
                " - " + moment(this.planningResaE.endStr).format("HH") +
                "h" + moment(this.planningResaE.endStr).format("mm");
            } else {
              this.resaModal = true;
              this.resaHeader =
                moment(this.planningResaE.startStr).format("ddd DD/MM/YY - HH") +
                "h" + moment(this.planningResaE.startStr).format("mm") +
                " - " + moment(this.planningResaE.endStr).format("HH") +
                "h" + moment(this.planningResaE.endStr).format("mm");
            }
          })
          .catch((error) => { console.log(error); });

        let mono = this.moniteurs.find((m) => m.idMono == this.monoChoixResa);
        const dateStr = moment(e.startStr).format("YYYY-MM-DD");
        this.boiteResa = this.getBoiteForDay(mono, dateStr).boite;
        this.lieuxMono = mono.lieux.filter((l) => l.get == true).map(l => ({ ...l, choixEleve: false }));
        if (this.$store.state.eleveSelectAgence != null) {
          this.getLieuEleve(this.$store.state.eleveSelectAgence);
        }
      }else if(this.$store.state.planningSelectChoice == "EXAM" && !e.allDay){
        this.showExamDiag = true;
      }else if(this.$store.state.planningSelectChoice == "EXAM BLANC" && !e.allDay){
        this.showExamBlancDiag = true;
      }
    },

    setDispo(e) {
      window.api
        .post(
          "/disponibilites",
          {
            start: moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            eleve: "api/utilisateurs/" + this.$store.state.eleveSelectAgence.id,
          },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then((response) => {
          this.$emit("getEleves");
          this.calendarOptions.events.push({
            id: response.data.id,
            title: "Dispo" + response.data.lieu,
            start: moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            color: "blue",
            type: "dispo",
          });
        })
        .catch((error) => { console.log(error); });
    },

    indispoEndpoint(type) {
      if (type === "semainetype") {
        return "/indispo_semaine_types/";
      }
      if (type === "indispo") {
        return "/indisponibilites/";
      }
      return null;
    },

    eventResizeIndispo(info) {
      const endpoint = this.indispoEndpoint(info.event.extendedProps.type);
      if (!endpoint) {
        info.revert();
        return;
      }
      window.api
        .put(
          endpoint + info.event._def.publicId,
          {
            start: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(info.event.end).format("YYYY-MM-DDTHH:mm:ss"),
          },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .catch((error) => {
          console.log(error);
          info.revert();
        });
    },

    eventDropIndispo(info) {
      const endpoint = this.indispoEndpoint(info.event.extendedProps.type);
      if (!endpoint) {
        info.revert();
        return;
      }
      let payload = {
        start: moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss"),
        end: moment(info.event.end).format("YYYY-MM-DDTHH:mm:ss"),
      };
      if (info.newResource) {
        payload.moniteur = "api/moniteurs/" + info.newResource.id;
      }
      window.api
        .put(
          endpoint + info.event._def.publicId,
          payload,
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .catch((error) => {
          console.log(error);
          info.revert();
        });
    },

    setIndispo(e) {
      window.api
        .post(
          "/indisponibilites",
          {
            start: moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            moniteur: "api/moniteurs/" + e["resource"]["_resource"]["id"],
          },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then((response) => {
          this.calendarOptions.events.push({
            id: response.data.id,
            title: "INDISPO",
            start: moment(e.startStr).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(e.endStr).format("YYYY-MM-DDTHH:mm:ss"),
            color: "#F3F2F2",
            textColor: "#5F5F5F",
            type: "indispo",
            motif: false,
            resourceId: e["resource"]["_resource"]["id"],
          });
        })
        .catch((error) => { console.log(error); });
    },

    moniteurChoicePlanning(moniteur, checked) {
      this.moniteursList = this.$store.state.moniteursPlanningAgence;
      if (checked) {
        this.moniteurchoix.push({ title: moniteur.surnom, id: moniteur.idMono });
        this.calendarOptions.resources = this.moniteurchoix;
        let moniteurFind = this.moniteursList.find((mono) => mono.idMono == moniteur.idMono);
        moniteurFind.checked = true;
        let moniteursFilter = this.moniteursList.filter((mono) => mono.idMono != moniteurFind.idMono);
        moniteursFilter.push(moniteurFind);
        this.moniteursList = moniteursFilter;
        this.$store.commit("setMoniteursPlanningAgence", this.moniteursList);
      } else {
        let filter = this.calendarOptions.resources.filter((mono) => mono.id != moniteur.idMono);
        this.calendarOptions.resources = filter;
        this.moniteurchoix = filter;
        let moniteurFind = this.moniteursList.find((mono) => mono.idMono == moniteur.idMono);
        moniteurFind.checked = false;
        let moniteursFilter = this.moniteursList.filter((mono) => mono.idMono != moniteurFind.idMono);
        moniteursFilter.push(moniteurFind);
        this.moniteursList = moniteursFilter;
        this.$store.commit("setMoniteursPlanningAgence", this.moniteursList);
      }
    },

    selectAllow(select) {
      return moment().diff(select.start) <= 0;
    },
  },
};
</script>

<style scoped>

div.calendar {
  display: flex;
}

div.calendarSide {
  overflow-x: auto;
  padding-bottom: 1rem;
  width: 60%;
  transform: rotateX(180deg);
}

div.calendarSideContent {
  transform: rotateX(180deg);
}

.fc {
  min-width: 1500px;
}

.fc-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

div.sidePlanning {
  position: relative;
  right: auto;
  border: 1px solid rgb(224, 224, 224);
  background-color: white;
  width: 40%;
  height: auto;
  max-height: 95vh;
  overflow-y: auto;
  z-index: auto;
}

div.split {
  position: absolute;
  background-color: white;
  z-index: 90;
  right: 0;
  height: 95vh;
  overflow: scroll;
}

div.split button {
  position: absolute;
  top: 10px;
  right: 10px;
}

input[type="text"]#motifText {
  width: 100%;
  padding: 12px 20px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

select.selectResaEleve {
  width: 100%;
  padding: 16px 20px;
  border: none;
  border-radius: 4px;
  margin-bottom: 1em;
  background-color: #f1f1f1;
}

select.monoSelectResaEleves {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  margin-bottom: 1em;
  background-color: #f1f1f1;
}

.selectMono {
  background-color: rgba(19, 192, 19, 0.2);
}

button.btnValMotif {
  margin-right: 50%;
}

/* ── Fond jaune jour actuel ── */
:deep(.fc-day-today) {
  background-color: #fffde7 !important;
}

/* ── En-têtes colonnes ── */
:deep(.fc-col-header-cell) {
  padding: 8px 0;
  font-size: 13px;
}

:deep(.fc-col-header-cell-cushion) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  text-transform: capitalize;
}

:deep(.fc-day-today .fc-col-header-cell-cushion) {
  color: #1a73e8;
}

/* ─────────────────────────────────────────
   STYLES DES ÉVÉNEMENTS — enrichis
───────────────────────────────────────── */
:deep(.fc-event) {
  border-radius: 6px !important;
  border: none !important;
  border-left: 3px solid rgba(0,0,0,.15) !important;
  font-size: 11px !important;
  padding: 3px 6px !important;
  box-shadow: none !important;
  transition: transform .1s, box-shadow .1s !important;
  overflow: hidden !important;
}

:deep(.fc-event:hover) {
  transform: translateY(-1px) !important;
  box-shadow: 0 3px 10px rgba(0,0,0,.12) !important;
}

/* Ligne "all-day" (badges BM/BA) : juste la hauteur des badges, pas plus */
:deep(.fc-daygrid-day-frame) {
  min-height: 0 !important;
  padding: 2px 0 !important;
}
:deep(.fc-daygrid-day-events) {
  margin: 0 !important;
  min-height: 0 !important;
}
:deep(.fc-daygrid-event-harness) {
  margin: 1px 3px !important;
}

/* Couleurs par classNames FullCalendar */
:deep(.fc .fc-event.ev-lecon) {
  background-color: #d8f2e8 !important;

  color: #065f46 !important;
}
:deep(.fc-event.ev-exam) {
  background: #eff6ff; border-left-color: #3b82f6; color: #1d4ed8;
}
:deep(.fc-event.ev-urgent) {
  background: #fff1f2; border-left-color: #f43f5e; color: #be123c;
}
:deep(.fc-event.ev-attente) {
  background: #fef3c7; border-left-color: #f59e0b; color: #92400e;
}
:deep(.fc-event.ev-indispo) {
  background: #f1f5f9; border-left-color: #94a3b8; color: #475569;
}

/* Heure de l'event */
:deep(.ev-time) {
  font-size: 10px;
  font-weight: 700;
  opacity: .75;
  display: block;
  margin-bottom: 1px;
  letter-spacing: .02em;
  flex-shrink: 0;
}

/* Titre (nom élève) */
:deep(.ev-title) {
  font-weight: 600;
  font-size: 12px;
  display: block;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

/* Lieux deb / fin */
:deep(.ev-meta) {
  font-size: 10.5px;
  opacity: .85;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
  flex-shrink: 0;
}

/* Ligne "RDV à [agence]" des events exam / exam blanc */
:deep(.ev-meta-bold) {
  font-weight: 700;
  opacity: 1;
}

/* Badge AAC — positionné en absolu dans le coin haut-droit de l'event (hors flux, jamais tronqué) */
:deep(.ev-badge) {
  position: absolute;
  top: 3px;
  right: 4px;
  font-size: 8.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .03em;
  padding: 2px 6px;
  border-radius: 20px;
  text-align: center;
  background: #ffffff;
  color: #1a1f2e;
  line-height: 1.4;
  box-shadow: 0 1px 3px rgba(0,0,0,.35);
  pointer-events: none;
  z-index: 1;
}

:deep(.ev-motif) {
  font-size: 9px;
  font-style: italic;
  margin-top: 3px;
  opacity: .85;
  flex-shrink: 0;
}

:deep(.ev-motif-bg) {
  font-size: 9px;
  font-style: italic;
  font-weight: 600;
  color: #be123c;
  padding: 2px 4px;
  pointer-events: none;
}

:deep(.fc-event-main) {
  padding: 0;
  height: 100%;
  overflow: hidden;
}

:deep(.ev-inner) {
  padding: 4px 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

/* ── Grille ── */
:deep(.fc-timegrid-slot) {
  height: 20px;
}


:deep(.fc-timegrid-slot-label) {
  font-size: 12px;
  color: #888;
}

:deep(.fc-scrollgrid) {
  border-color: #e0e0e0 !important;
}

:deep(.fc-scrollgrid td),
:deep(.fc-scrollgrid th) {
  border-color: #e0e0e0 !important;
}

/* ── Toolbar ── */
:deep(.fc-toolbar) {
  padding: 4px 10px;
  margin-bottom: 4px !important;
}

:deep(.fc-toolbar-title) {
  font-size: 18px !important;
}

:deep(.fc-button-group),
:deep(.fc-button) {
  box-shadow: none !important;
  outline: none !important;
}

:deep(.fc-prev-button),
:deep(.fc-next-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 50% !important;
  color: #555 !important;
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.fc-prev-button:hover),
:deep(.fc-next-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-today-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 3px 10px !important;
  text-transform: capitalize !important;
}

:deep(.fc-today-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-today-button:disabled) {
  opacity: 0.5 !important;
}

:deep(.fc-resourceTimeGridWeek-button),
:deep(.fc-resourceTimeGridDay-button),
:deep(.fc-hideSunday-button) {
  background-color: transparent !important;
  border: none !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 3px 10px !important;
}

:deep(.fc-resourceTimeGridWeek-button:hover),
:deep(.fc-resourceTimeGridDay-button:hover),
:deep(.fc-hideSunday-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-resourceTimeGridWeek-button.fc-button-active),
:deep(.fc-resourceTimeGridDay-button.fc-button-active),
:deep(.fc-hideSunday-button.fc-button-active) {
  background-color: #e8f0fe !important;
  border-color: #e8f0fe !important;
  color: #1a73e8 !important;
}

:deep(.fc-toolbar-chunk:last-child) {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 1px 3px;
}

/* ── DataTable ── */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}

:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

/* ===================== DIALOG DESIGN SYSTEM ===================== */

.d-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 4px 0 8px;
}

.d-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.d-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.d-label {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: .05em;
}

.d-select {
  width: 100%;
  padding: 10px 36px 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1f2e;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 12px center;
  -webkit-appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
}
.d-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

.d-input {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1f2e;
  background: #fff;
  outline: none;
  transition: border-color .15s;
  box-sizing: border-box;
}
.d-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

.d-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.d-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  font-family: inherit;
}
.d-btn--primary { background: #3b82f6; color: #fff; }
.d-btn--primary:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.3); }
.d-btn--secondary { background: #e8f0fe; color: #1d4ed8; border: 1.5px solid #bfdbfe; }
.d-btn--secondary:hover:not(:disabled) { background: #dbeafe; }
.d-btn--ghost { background: transparent; color: #64748b; border: 1.5px solid #e2e8f0; }
.d-btn--ghost:hover:not(:disabled) { background: #f8fafc; border-color: #94a3b8; }
.d-btn--warning { background: #fef3c7; color: #b45309; border: 1.5px solid #fde68a; }
.d-btn--warning:hover:not(:disabled) { background: #fde68a; }
.d-btn--danger { background: #fee2e2; color: #dc2626; border: 1.5px solid #fca5a5; }
.d-btn--danger:hover:not(:disabled) { background: #fca5a5; color: #fff; }
.d-btn--block { width: 100%; justify-content: center; }
.d-btn:disabled { opacity: .5; cursor: not-allowed; }

.overlap-warning {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  border-radius: 10px;
  padding: 10px 14px;
  margin: 12px 0;
  font-size: 13px;
}
.overlap-warning svg { flex-shrink: 0; }
.overlap-warning-text { flex: 1; }
.overlap-warning-btn {
  flex-shrink: 0;
  background: #fbbf24;
  color: #431407;
  border: none;
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.overlap-warning-btn:hover:not(:disabled) { background: #f59e0b; }
.overlap-warning-btn:disabled { opacity: .6; cursor: not-allowed; }

.simu-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px;
  background: #eff6ff;
  border-radius: 14px;
  border: 1.5px solid #bfdbfe;
}

.simu-icon {
  width: 46px;
  height: 46px;
  background: #3b82f6;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simu-desc { font-size: 12px; color: #64748b; margin: 0; }
.simu-lieu { font-size: 16px; font-weight: 700; color: #1d4ed8; margin: 2px 0 0; }

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  div.calendar {
    flex-direction: column;
  }

  div.calendarSide {
    width: 100% !important;
  }

  div.sidePlanning {
    width: 100% !important;
    max-height: 55vh;
  }

  div.split {
    position: static;
    width: 100%;
    height: auto;
    max-height: 60vh;
    overflow-y: auto;
  }

  div.head {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  select.selectResaEleve {
    width: 100%;
    padding: 12px 14px;
  }

  input[type="text"]#motifText {
    font-size: 14px;
  }

  /* Le calendrier reste scrollable horizontalement */
  div.calendarSide {
    overflow-x: auto;
  }

  :deep(.fc-toolbar) {
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px 6px;
  }

  :deep(.fc-toolbar-chunk) {
    display: flex;
    gap: 4px;
  }

  :deep(.fc-toolbar-title) {
    font-size: 14px !important;
  }
}

</style>

<style>
/* Non-scoped : le Dialog "Réservation" téléporte son contenu vers document.body,
   ce qui échappe au CSS scoped ci-dessus. */
.resa-eleve-dialog .p-dialog-header {
  position: relative;
  padding: 0;
  background: linear-gradient(135deg, #559cf5 0%, #1a73e8 100%);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.resa-eleve-dialog .p-dialog-header-icons {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  z-index: 2;
}

.resa-eleve-dialog .p-dialog-header-icon,
.resa-eleve-dialog .p-dialog-header-icon:enabled:hover {
  width: 28px !important;
  height: 28px !important;
  border-radius: 6px !important;
  background: #ef4444 !important;
  color: #fff !important;
}

.resa-eleve-dialog .p-dialog-header-icon:enabled:hover {
  background: #dc2626 !important;
}

div.resa-eleve-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 56px 18px 24px;
  width: 100%;
}

div.resa-eleve-banner-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

span.resa-eleve-banner-eleve {
  font-size: 19px;
  font-weight: 800;
  color: #fff;
  letter-spacing: .2px;
}

span.resa-eleve-banner-date {
  font-size: 13px;
  font-weight: 600;
  color: #d0e4ff;
}

span.resa-eleve-banner-boite {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 4px 14px;
  border-radius: 20px;
  background: rgba(255,255,255,.18);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

div.resa-head {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}


div.resa-head-toggles {
  display: flex;
  align-items: center;
  gap: 16px;
}

label.resa-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}

label.resa-toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
  cursor: pointer;
}

div.resa-table-wrap {
  margin-bottom: 20px;
}

table.resa-eleves-table.p-datatable-table,
div.resa-eleves-table.p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 13px;
}

div.resa-eleves-table .p-datatable-thead > tr > th {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

div.resa-eleves-table .p-datatable-tbody > tr {
  background: #ffffff;
  transition: background 0.15s;
}

div.resa-eleves-table .p-datatable-tbody > tr:hover {
  background: #f9fafb;
  cursor: pointer;
}

div.resa-eleves-table .p-datatable-tbody > tr > td {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
}

div.resa-eleves-table .p-datatable-tbody > tr > td:nth-child(2) {
  font-weight: 700;
  color: #1a1f2e;
}

input.resa-radio {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
  cursor: pointer;
}

ul.resa-paginator.p-paginator,
div.resa-paginator {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px;
}

div.resa-lieux {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

div.resa-lieux div.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 240px;
  flex: 1;
}

div.resa-lieux label.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

div.resa-lieux select.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  box-sizing: border-box;
  outline: none;
}

div.resa-lieux select.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

div.resa-warning {
  padding: 14px 16px;
  border-radius: 10px;
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
}

div.resa-actions {
  display: flex;
  justify-content: flex-end;
}

button.resa-validate-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  background: #3b82f6;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.15s;
}

button.resa-validate-btn:hover:not(:disabled) {
  background: #2563eb;
}

button.resa-validate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>